export default {
    de: {
        // GENERAL
        // GENERAL
        // GENERAL
        // GENERAL
        "menu.topbar.locations": `
            Mecklenburg-Vorpommern · Nordrhein-Westfalen · Baden-Württemberg · Schleswig-Holstein
        `,
        "menu.page.home": "Home",
        "menu.page.loesungen": "Lösungen",
        "menu.page.loesungen.leitsysteme": "Leitstellensysteme",
        "menu.page.loesungen.wachenelw": "Wachen und ELW",
        "menu.page.loesungen.einsatznavigation": "Einsatznavigation",
        "menu.page.loesungen.sprachdatenfunk": "Sprach- und Datenfunk",
        "menu.page.loesungen.digitalalarm": "Digitale Alarmierung",
        "menu.page.loesungen.repair": "Wartungen/Reparaturen",
        "menu.page.loesungen.it": "IT",
        "menu.page.about": "Über uns",
        "menu.page.about.niederlassungen": "Standorte",
        "menu.page.about.unserewerte": "Unsere Werte",
        "menu.page.about.about": "Über Sinus",
        "menu.page.about.management": "Management",
        "menu.page.about.umwelt": "Umwelt",
        "menu.page.about.team": "Das Team",
        "menu.page.about.partner": "Partner",
        "menu.page.about.certificates": "Zertifikate",
        "menu.page.about.verbaende": "Verbände",
        "menu.page.news": "Aktuelles",
        "menu.page.news.termine": "Termine",
        "menu.page.news.wirwachsen": "Wir wachsen",
        "menu.page.news.news": "News",
        "menu.page.career": "Karriere",
        "menu.page.contact": "Kontakt",
        "btn.readmore": "Mehr lesen",
        "fetch.posts.loading": "Lade Beiträge...",
        "fetch.posts.error": "Beiträge konnten nicht geladen werden.",
        "fetch.posts.empty": "Keine Beiträge gefunden.",
        "fetch.post.loading": "Lade Beitrag...",
        "fetch.post.error": "Beitrag konnte nicht geladen werden.",
        "pagepreviews.leitstellen.headline": "Leitstellensysteme",
        "pagepreviews.leitstellen.p": `
            Wenn es auf jede Sekunde ankommt, bietet unser MECC-System 
            eine zuverlässige Lösung.
        `,
        "pagepreviews.wachenelw.headline": "Wachen und ELW",
        "pagepreviews.wachenelw.p": `
            Zuverlässige und schnelle Kommunikation zwischen den 
            Einsatzkräften im Einsatz.
        `,
        "pagepreviews.einsatznavigation.headline": "Einsatznavigation",
        "pagepreviews.einsatznavigation.p": `
            Effiziente TETRA Navigation & Kommunikation – Flexibel. Robust. Vernetzt.
        `,
        "pagepreviews.sprachdaten.headline": "Sprach- und Datenfunk",
        "pagepreviews.sprachdaten.p": `
            Funksysteme für Sprach- und Datenkommunikation sind 
            heute ein entscheidender Faktor.
        `,
        "pagepreviews.digitalalarm.headline": "Digitale Alarmierung",
        "pagepreviews.digitalalarm.p": `
            Nach Auslösung eines Notrufs kommt es auf 
            ein effektives Alarmierungssystem an.
        `,
        "pagepreviews.repair.headline": "Reparaturen",
        "pagepreviews.repair.p": `
            Investitionsschutz bieten Ihnen unsere qualifizierten Werkstätten.
        `,
        "pagepreviews.itservice.headline": "IT-Dienstleistungen",
        "pagepreviews.itservice.p": `
            Die Planung, Umsetzung sowie Unterstützung im laufenden 
            Betrieb von IT-Infrastrukturen verlangt einen starken Partner. 
            Nutzen Sie unsere jahrzehntelange Erfahrung.
        `,
        "footer.col.about.heading": "Über uns",
        "footer.col.about.gmaplink": "Standorte auf Google Maps",
        "footer.col.about.link.team": "Team",
        "footer.col.about.link.partner": "Partner",
        "footer.col.about.link.certificates": "Zertifikate",
        "footer.col.about.link.verbaende": "Verbände",
        "footer.col.about.link.karriere": "Karriere bei SINUS",
        "footer.col.downloads.heading": "Downloads & Software",
        "footer.col.downloads.link.teamviewer": "TeamViewer QuickSupport",
        "footer.col.downloads.link.alf": "Allgemeine Lieferbedingungen",
        "footer.col.downloads.link.repform": "Reparaturauftragsformular",
        "footer.col.downloads.link.freeform": `
            Freistellungsbescheinigung <br />
            nach § 48b Abs. 1 EStG
        `,
        "footer.col.location.ludwigsburg.heading": "Standort <br />Ludwigsburg",
        "footer.col.location.ludwigsburg.address": `
            Voithstraße 4-6 <br />
            71640 Ludwigsburg
        `,
        "footer.col.location.barsbuettel.heading": "Zentrale <br />Barsbüttel",
        "footer.col.location.barsbuettel.address": `
            Rahlstedter Straße 13 <br />
            22885 Barsbüttel
        `,
        "footer.col.location.greifwald.heading": "Standort <br />Greifswald",
        "footer.col.location.greifwald.address": `
            Ziegelhof 7 <br />
            17489 Greifswald
        
        `,
        "footer.col.location.unna.heading": "Standort <br />Unna",
        "footer.col.location.unna.address": `
            Kamener Straße 110 <br />
            59425 Unna        
        `,
        "footer.col.location.pforzheim.heading": "Standort Entwicklung <br /> Pforzheim",
        "footer.col.location.pforzheim.address": `
            Welschenäckerstraße 10 <br />
            75177 Pforzheim
        `,
        "footer.bottombar.copyright": "@ Copyright SINUS Nachrichtentechnik GmbH",
        "footer.bottombar.link.privacy": "Datenschutz",
        "footer.bottombar.link.imprint": "Impressum",
        "footer.bottombar.link.hinweisgeberschutz": "Hinweisgeberschutz",
        // FILES
        // FILES
        // FILES
        // FILES
        // FILES
        "file.pdf.mecc.info": "https://liveicomcdn.blob.core.windows.net/sinus/files/MECC_2024.pdf",
        "file.pdf.mecc.info.name": "MECC Informationsbroschüre",
        // FORM
        // FORM
        // FORM
        // FORM
        // FORM
        // FORM
        "form.placeholder.required": "Pflichtfeld",
        "form.placeholder.select": "Bitte auswählen",
        // modals
        // modals
        // modals
        // modals
        // modals
        "modal.btn.close": "Schließen",
        "modal.contact.headline.top": "Allgemeines Kontaktformular",
        "modal.contact.form.field.topic": "Ihre Anfrage",
        "modal.contact.form.field.topic.leitstellensysteme": "Leitstellensysteme",
        "modal.contact.form.field.topic.wachen-elw": "Wachen und ELW",
        "modal.contact.form.field.topic.einsatznavigation": "Einsatznavigation",
        "modal.contact.form.field.topic.sprach-datenfunk": "Sprach- und Datenfunk",
        "modal.contact.form.field.topic.digitale-alarmierung": "Digitale Alarmierung",
        "modal.contact.form.field.topic.wartung-reparaturen": "Wartung/Reparaturen",
        "modal.contact.form.field.topic.it": "IT",
        "modal.contact.form.field.ansprache": "Ansprache",
        "modal.contact.form.field.ansprache.1": "Frau",
        "modal.contact.form.field.ansprache.2": "Herr",
        "modal.contact.form.field.ansprache.3": "Divers",
        "modal.contact.form.field.firstname": "Vorname",
        "modal.contact.form.field.lastname": "Nachname",
        "modal.contact.form.field.firmname": "Unternehmen",
        "modal.contact.form.field.email": "E-Mail",
        "modal.contact.form.field.phone": "Telefon",
        "modal.contact.form.field.bundesland": "Bundesland",
        "modal.contact.form.field.bundesland.1": "Baden-Württemberg",
        "modal.contact.form.field.bundesland.2": "Bayern",
        "modal.contact.form.field.bundesland.3": "Berlin",
        "modal.contact.form.field.bundesland.4": "Brandenburg",
        "modal.contact.form.field.bundesland.5": "Bremen",
        "modal.contact.form.field.bundesland.6": "Hamburg",
        "modal.contact.form.field.bundesland.7": "Hessen",
        "modal.contact.form.field.bundesland.8": "Mecklenburg-Vorpommern",
        "modal.contact.form.field.bundesland.9": "Niedersachsen",
        "modal.contact.form.field.bundesland.10": "Nordrhein-Westfalen",
        "modal.contact.form.field.bundesland.11": "Rheinland-Pfalz",
        "modal.contact.form.field.bundesland.12": "Saarland",
        "modal.contact.form.field.bundesland.13": "Sachsen",
        "modal.contact.form.field.bundesland.14": "Sachsen-Anhalt",
        "modal.contact.form.field.bundesland.15": "Schleswig-Holstein",
        "modal.contact.form.field.bundesland.16": "Thüringen",
        "modal.contact.form.field.message": "Ihre Nachricht",
        "modal.contact.form.field.privacy": "Datenschutz",
        "modal.contact.form.field.privacytext": "Hiermit erklären Sie sich einverstanden, dass die von Ihnen angegebenen Daten elektronisch erhoben und gespeichert werden. Weitere Informationen entnehmen Sie unserer <a href='datenschutz'>Datenschutzerklärung</a>.",
        "modal.contact.form.btn.send": "Absenden",
        "modal.contact.form.btn.sending": "Wird gesendet...",
        "modal.contact.form.sendingfeedback.success": "Vielen Dank für Ihre Nachricht. Wir werden uns schnellstmöglich bei Ihnen melden.",
        "modal.contact.form.sendingfeedback.error": "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
        "modal.contact.headline.bottom": "Ihr direkter Draht zum <br />richtigen Ansprechpartner.",
        "modal.contact.btn.locations": "Unsere Standorte",
        // 404
        // 404
        // 404
        // 404
        // 404
        "page.404.headline": "404",
        "page.404.subline": "Seite nicht gefunden",
        "page.404.btn.home": "Zur Startseite",
        // specials
        // specials
        // specials
        // specials
        // specials
        "special.stoerer.btn.close": "Schließen",
        "special.stoerer.subline": "Hamburger Gründerpreis 2024",
        "special.stoerer.btn.readmore": "Mehr erfahren",
        "special.stoerer.p": "Wir sind in der Kategorie Aufsteiger ausgezeichnet!",
        // HOME
        // HOME
        // HOME
        // HOME
        "page.home.hero.slider.1.work": "Projektmanagerin Systemtechnik",
        "page.home.hero.slider.1.name": "Bea Arnz",
        "page.home.hero.slider.1.img": "https://liveicom.azureedge.net/sinus/img/members/Bea_Arnz_Projektmanagerin_Systemtechnik_3G9A7141.png",
        "page.home.hero.slider.1.headline": "Weil jede Sekunde zählt",
        "page.home.hero.slider.2.work": "Leitung Marketing & Vertrieb",
        "page.home.hero.slider.2.name": "Tjark Süchting",
        "page.home.hero.slider.2.img": "https://liveicom.azureedge.net/sinus/img/members/tjark_suechting.png",
        "page.home.hero.slider.2.headline": "Weil jede Sekunde zählt",
        "page.home.hero.slider.3.work": "Teamleiter IT",
        "page.home.hero.slider.3.name": "Tobias Swiderski",
        "page.home.hero.slider.3.img": "https://liveicom.azureedge.net/sinus/img/members/Tobias-Swidersk.png",
        "page.home.hero.slider.3.headline": "Weil jede Sekunde zählt",
        "page.home.hero.slider.4.work": "Techniker Systemtechnik",
        "page.home.hero.slider.4.name": "Frederic Westensee",
        "page.home.hero.slider.4.img": "https://liveicom.azureedge.net/sinus/img/members/Frederic-Westensee.png",
        "page.home.hero.slider.4.headline": "Weil jede Sekunde zählt",
        "page.home.subline": "SEIT 1983 FÜR SIE 24/7 IN RUFBEREITSCHAFT",
        "page.home.counter.seconds": "SEKUNDEN",
        "page.home.counter.days": "TAGE",
        "page.home.counter.years": "JAHRE",
        "page.home.counter.p.shortintroduction": `
            Als Hersteller, Systemintegrator und Großhändler in einem,
            bieten wir seit mehr als 40 Jahren Produkte, Lösungen und
            Service rund um den gesamten Bereich der Kommunikationstechnik.
            Wir sind gesellschaftergeführt und entwickeln hochverfügbare,
            integrierte Kommunikationssysteme für nahezu alle Branchen.
        `,
        "page.home.circleinfo.1.title": "BOS",
        "page.home.circleinfo.1.text": "Einsatzorganisationen aus allen Bereichen bedienen sich unserer Expertise",
        "page.home.circleinfo.2.title": "Stadtwerke",
        "page.home.circleinfo.2.text": "Regionale Versorgung sichern mit uns als Partner",
        "page.home.circleinfo.3.title": "Maritim",
        "page.home.circleinfo.3.text": "Auf allen Gewässern nicht nur bei MAY DAY",
        "page.home.circleinfo.4.title": "ÖPNV",
        "page.home.circleinfo.4.text": "Mit uns funkt's – zu Straßenbahn, Bussen und U-Bahnen",
        "page.home.circleinfo.5.title": "Industrie",
        "page.home.circleinfo.5.text": "Innovative Lösungen für alle Branchen",
        "page.home.circleinfo.6.title": "Flughafen",
        "page.home.circleinfo.6.text": "Always Happy Landings",
        "page.home.circleinfo.7.title": "Kontakt",
        "page.home.circleinfo.7.text": "Wir freuen uns auf Ihre Anfrage",
        "page.home.circleinfo.7.btn": "Kontakt",
        "page.home.footer.cta.more": "Mehr über uns",
        "page.home.footer.cta.news": "Aktuelles",
        // LEITSYSTEME
        // LEITSYSTEME
        // LEITSYSTEME
        // LEITSYSTEME
        "page.leitsysteme.hero.headline": "",
        "page.leitsysteme.headline": "Leitstellensysteme",
        "page.leitsysteme.subline": "In einer Welt, in der jede Sekunde zählt",
        "page.leitsysteme.p.1": `
            Ein Disponent muss auf Knopfdruck mehrere Systeme und unterschiedliche 
            Funktionen möglichst parallel ansteuern können, meistens auch gleichzeitig. 
            Nur so kann schnelle Hilfeleistung gewährleistet werden.
        `,
        "page.leitsysteme.p.2": `
            Mit unserem MECC Kommunikationssystem bieten wir eine hochverfügbare, flexible und intuitiv
            bedienbare Lösung für kleine und große Leitstellen an. Dabei kann das
            Kommunikationsmanagementsystem eine eigenständige Lösung oder eine Komplettintegration des
            Einsatzleitsystems sein.
        `,
        "page.leitsysteme.p.3": `
            Durch eine Vielzahl an Schnittstellen und der individuellen 
            Anpassungsmöglichkeiten lässt sich unser MECC System in jede Leitstelle als 
            Bestandteil sämtlicher Prozesse integrieren.
        `,
        "page.leitsysteme.p.4": `
            Unser hochqualifiziertes Team bietet Ihnen auch nach erfolgreicher 
            Projektabwicklung einen sicheren Service – und dies täglich (24/7).
        `,
        "page.leitsysteme.btn.infopdf": "MECC Informationsbroschüre",
        "page.leitsysteme.btn.projectrequest": "Projektanfrage stellen",
        // WACHEN ELW
        // WACHEN ELW
        // WACHEN ELW
        // WACHEN ELW
        "page.wachenelw.hero.headline": "",
        "page.wachenelw.headline": "Wachen und ELW",
        "page.wachenelw.subline": "Zuverlässige und schnelle Kommunikation zwischen den Einsatzkräften",
        "page.wachenelw.p.1": `
            Im Einsatz kommt es auf zuverlässige und schnelle Kommunikation zwischen den
            Einsatzkräften an. Gefordert ist eine klare Funktionalität.
        `,
        "page.wachenelw.p.2": `
            Mit der Funkbedienung SEB Voip Fire oder unseren Statusdisplays und Wachenmonitore
            können die Abläufe bei Schadensereignissen strukturiert und bedienerfreundlich
            abgearbeitet werden.
        `,
        "page.wachenelw.p.3": `
            Für die interne Kommunikation in Wachen und Gerätehäusern bieten wir skalierbare
            Lösungen für Telefonanlagen und elektronische Lautsprecheranlagen (ELA).
        `,
        "page.wachenelw.p.4": `
            Die Leistungsfähigkeit unserer Lösungen und unseres Teams stellen wir auch in
            diversen Projekten unter Beweis, in welchen Einsatzleitwagen nach zahlreichen
            Dienstjahren von uns technisch modernisiert werden.
        `,
        "page.wachenelw.btn.kontakt": "ANFRAGE",
        "page.wachenelw.btn.projectrequest": "Projektanfrage stellen",
        "page.wachenelw.dropdown.infomaterial": "Infomaterial",
        // einsatznavigation
        // einsatznavigation
        // einsatznavigation
        // einsatznavigation
        "page.einsatznavigation.hero.headline": "",
        "page.einsatznavigation.headline": "EFFIZIENTE TETRA NAVIGATION & FUNKBEDIENUNG",
        "page.einsatznavigation.subline": "Flexibel. Robust. Vernetzt.",
        "page.einsatznavigation.p.1": `
            Die <strong>TETRAcontrol UBX</strong> für Fahrzeuge ist die mobile Digitalfunk- und Steuerungslösung, die Navigation, Kommunikation und Datenmanagement vereint. Durch den Anschluss an Sepura- oder Motorola-Funkgeräte ermöglicht sie eine intuitive Funkbedienung per App, GPS- und Statusweiterleitung sowie Einsatznavigation mit automatischem Routenstart. Robuste Einsatztablets, die über die serielle Schnittstelle angeschlossen werden können, bieten eine übersichtliche Online- und Offline-Navigation und sind dank vielseitigem Zubehör auch für andere Applikationen an der Einsatzstelle voll nutzbar. Erweiterte Funktionen wie Bluetooth-Schnittstellen und LTE-Datenübertragung machen sie zur optimalen Lösung für Einsatzkräfte. Modular erweiterbar und individuell konfigurierbar – für maximale Effizienz im Einsatz.
        `,
        "page.einsatznavigation.btn.kontakt": "ANFRAGE",
        "page.einsatznavigation.btn.projectrequest": "Projektanfrage stellen",
        "page.einsatznavigation.dropdown.infomaterial": "Infomaterial",
        // sprach datenfunk
        // sprach datenfunk
        // sprach datenfunk
        // sprach datenfunk
        "page.sprachdaten.hero.headline": "",
        "page.sprachdaten.headline": "Sprach- und Datenfunk",
        "page.sprachdaten.subline": "Alles aus einer Hand - Analog & Digital",
        "page.sprachdaten.p.1": `
            Wenn es um den Informationsaustausch geht, sind Systeme für 
            Sprach- und Datenkommunikation ein entscheidender Faktor in 
            allen Bereichen der Wirtschaft. Unser Leistungsspektrum umfasst 
            die Planung, Installation und Wartung von Richtfunkverbindungen, 
            analoger und digitaler ortsfesten Funkstellen sowie flächendeckender 
            Gleichwellenfunkanlagen.
        `,
        "page.sprachdaten.btn.contact": "ANFRAGE",
        "page.sprachdaten.dropdown.infomaterial": "Infomaterial",
        "page.sprachdaten.btn.projectrequest": "Projektanfrage stellen",
        // DIGITALE ALARMIERUNG
        // DIGITALE ALARMIERUNG
        // DIGITALE ALARMIERUNG
        // DIGITALE ALARMIERUNG
        "page.digitalalarm.hero.headline": "",
        "page.digitalalarm.headline": "Digitale Alarmierung",
        "page.digitalalarm.subline": "Unsere effektiven Benachrichtigungssysteme",
        "page.digitalalarm.p": `
            Nach Auslösung eines Notrufs kommt es auf eine effektive Alarmierung an. 
            Nur so kann die Zusammenführung von Einsatzkräften oder die 
            Benachrichtigung der Zielgruppen unmittelbar und zielführend gewährleistet werden.
        `,
        "page.digitalalarm.box.1.headline": "Im Notfall",
        "page.digitalalarm.box.1.p": `
            ...ist es entscheidend, dass Ersthelfer an jedem Ort und unter 
            den schwierigsten Umständen schnell erreichbar sind. 
            Bei Alleinarbeit oder in gefährlichen Umgebungen müssen 
            Mitarbeiter in der Lage sein, rasch und zuverlässig Hilfe zu rufen.
        `,
        "page.digitalalarm.box.2.headline": "Unsere Lösungen",
        "page.digitalalarm.box.2.p.1": `
            Mit unseren Systemen bieten wir maßgeschneiderte Lösungen für die schnelle, 
            zeitgleiche und zuverlässige Alarmierung über Schaltkontakte und die 
            Medien SMS, Pager, E-Mail, Sprachansagen, Textkonserven und 
            Lautsprecherdurchsagen.
        `,
        "page.digitalalarm.box.2.p.2": `
            Als Großhändler für Funkgeräte und Zubehör bieten wir kundenspezifische 
            Lösungen auch für analogen Betriebsfunk, TETRA, DMR, Seefunk, etc.
        `,
        "page.digitalalarm.btn.projectrequest": "Projektanfrage stellen",
        // REPARATUREN
        // REPARATUREN
        // REPARATUREN
        // REPARATUREN
        "page.repair.hero.headline": "zuverlässig und <br>schnell",
        "page.repair.headline": "Wartungen/Reparaturen",
        "page.repair.subline": "Planbare und zuverlässige Leistung für Ihren Einsatz!",
        "page.repair.p.1": `
            Um die Zuverlässigkeit der kritischen Systeme zu gewährleisten, ist eine
            stetige <strong>Pflege und Wartung</strong> notwendig. Wir bieten Ihnen auf
            Ihre Bedürfnisse zugeschnittene Wartungsverträge, die Ihnen größtmögliche
            Sicherheit geben.
        `,
        "page.repair.p.2": `
            Vor Ort oder an unseren Standorten Barsbüttel und Greifswald führen wir 
            <strong>Reparaturen</strong> an defekten Geräten, wie Meldeempfänger, 
            Funkgeräte und Funkanlagen mit Originalteilen der Hersteller durch.
        `,
        "page.repair.btn.repairpdf": "Reparaturauftragsformular",
        "page.repair.btn.contact": "Anfrage",
        // IT SERVICE
        // IT SERVICE
        // IT SERVICE
        // IT SERVICE
        "page.itservice.hero.headline": "",
        "page.itservice.headline": "IT",
        "page.itservice.subline": "Rundum Service - Rundum zufrieden",
        "page.itservice.p.1": `
            Wir unterstützen Sie bei der Planung, der Umsetzung sowie im laufenden Betrieb von
            IT-Infrastrukturen – ganz nach Ihrem Bedarf! Unser Leistungsspektrum deckt Ihre
            Anforderungen, vom WLAN Access Point bis zur komplexen Standortvernetzung oder der
            Virtualisierung kompletter Leitstellensysteme.
        `,
        "page.itservice.p.2": `
            Den Fokus setzen wir dabei auf das komplette IT-Umfeld für das 
            Kommunikationsmanagement- und Einsatzleitsystem.
        `,
        "page.itservice.p.3": `
            Nach erfolgreicher Umsetzung stehen wir Ihnen zudem für die Wartung und 
            Pflege der Systeme zur Seite.
        `,
        "page.itservice.p.4": `
            Unser hochqualifiziertes Team bietet Ihnen einen 
            sicheren Service – und dies täglich (24/7).
        `,
        "page.itservice.btn.contact": "Anfrage",
        // KARRIERE
        // KARRIERE
        // KARRIERE
        // KARRIERE
        "page.career.hero.slide.1.work": "ABTEILUNGSLEITERIN-VERWALTUNG",
        "page.career.hero.slide.1.name": "Carmen Anders",
        "page.career.hero.slide.1.headline": "Weil jede Sekunde zählt",
        "page.career.hero.slide.1.img": "https://liveicom.azureedge.net/sinus/img/members/carmen_anders.png",
        "page.career.headline": "Karriere mit Perspektive",
        "page.career.subline": "Unsere Devise: Wir sind ein Team!",
        "page.career.p.1": `
            Wir sind überzeugt davon, dass der Erfolg eines Unternehmens 
            maßgeblich vom Zusammengehörigkeitsgefühl aller Mitarbeitenden 
            abhängt und auf der Summe des Engagements aller Kollegen basiert. 
            Unter dieser Devise leben wir ein Miteinander, das durch Respekt, 
            Wertschätzung, Vertrauen, Gleichstellung, Spaß und 
            Hilfsbereitschaft geprägt ist.
        `,
        "page.career.p.2": `
            Neue Kolleginnen und Kollegen werden durch einen nachhaltigen 
            Onboarding Prozess im Team integriert. Durch unser Mentorenprogramm 
            steht ein Ansprechpartner zur Seite, ein Einarbeitungsplan 
            ermöglicht die strukturierte Integration in Prozesse und 
            Aufgaben und regelmäßige Feedbackgespräche schaffen Klarheit 
            und fördern die Kommunikation.
        `,
        "page.career.chances.headline": "Nachwuchsförderung",
        "page.career.chances.subline": "Deine Chance - Gemeinsam etwas bewegen",
        "page.career.chances.p": `
            Wir sehen in dem Bedarf gut ausgebildeter Fachkräfte auch eine
            Verpflichtung, sich an der Aus- und Weiterbildung zu beteiligen.
            Bewerber, die motiviert dem Berufsleben entgegensehen, wollen wir die
            bestmögliche Unterstützung zukommen lassen. Dabei spielt es keine Rolle,
            ob es sich um eine Ausbildung im technischen oder kaufmännischen
            Bereich, ein duales Studium, die Begleitung einer Bachelorarbeit oder
            ein Praktikum handelt - jede Bewerbung ist willkommen.
        `,
        "page.career.impressions.headline": "Benefits",
        "page.career.impressions.subline": "Das hast du nun davon",
        "page.career.impressions.li.1": "Onboarding Prozess",
        "page.career.impressions.li.2": "Kultur der offenen Türen",
        "page.career.impressions.li.3": "Teamspirit",
        "page.career.impressions.li.4": "Mentorenprogramm",
        "page.career.impressions.li.5": "Werthaltige Tätigkeit (Blaulicht)",
        "page.career.impressions.li.6": "Flexible Arbeitszeiten",
        "page.career.impressions.li.7": "Überstundenkonto",
        "page.career.impressions.li.8": "30 Tage Urlaub",
        "page.career.impressions.li.9": "Mobiles Arbeiten",
        "page.career.impressions.li.10": "Betriebliche Altersvorsorge -> Arbeitgeberzuschuss über die gesetzlichen Vorgaben hinaus",
        "page.career.impressions.li.11": "Firmenwagen",
        "page.career.impressions.li.12": "Smartphone",
        "page.career.impressions.li.13": "Neues, ökologisches Gebäude",
        "page.career.impressions.li.14": "Ergonomisch eingerichteter Arbeitsplatz (höhenverstellbarer Tisch, mehrere Monitore etc.)",
        "page.career.impressions.li.15": "Getränke, Obst",
        "page.career.impressions.li.16": "Fortbildungen intern/extern",
        "page.career.impressions.li.17": "Firmenevents",
        "page.career.impressions.li.18": "Anbindung (Autobahnen/ Parkplatz vorhanden)",
        "page.career.joblistings.headline": "Offene Stellen",
        "page.career.ctasection.subline": "Carmen Anders",
        "page.career.ctasection.jobtitle": "Abteilungsleiterin-Verwaltung",
        "page.career.ctasection.p": `
            Wir freuen uns dich kennenzulernen. <br />
            Initiativbewerbungen? Ja, bitte.
        `,
        "page.career.ctasection.btn.locations": "Zu den Standorten",
        "page.career.ctasection.btn.contact": "Jetzt Kontakt aufnehmen",
        // TERMINE
        // TERMINE
        // TERMINE
        // TERMINE
        "page.events.hero.headline": "Mit der Zukunft<br>vernetzt",
        "page.events.headline": "Termine",
        "page.events.subline": "Wir sehen uns",
        "page.events.btn.event": "zum Termin",
        // WIR WACHSEN
        // WIR WACHSEN
        // WIR WACHSEN
        // WIR WACHSEN
        "page.growth.hero.headline": "zuverlässig und <br>schnell",
        "page.growth.headline": "Wir wachsen!",
        "page.growth.subline": "Neue Sinus Zentrale in Barsbüttel: Arbeiten mit Wohlfühlfaktor!",
        "page.growth.p.1": `
            Ende 2023 sind wir in unseren <strong>energieeffizienten</strong> und
            <strong>ökologischen</strong> Neubau in Barsbüttel umgezogen, Energierückgewinnung
            und ein hoher Autarkiegrad sichern einen zukunftsorientierten Arbeitsort.
            Das dreistöckige Gebäude, wurde von den Mitarbeitenden nach den jeweiligen
            Bedarfen mitgestaltet.
        `,
        "page.growth.p.2": `
            Seid gespannt, was sich in Kürze weiter Spannendes im Neubau tun wird!
        `,
        // NEWS
        // NEWS
        // NEWS
        // NEWS
        "page.news.hero.headline": "mit der Zukunft <br>vernetzt",
        "page.news.headline": "News",
        "page.news.subline": "Innovationen die begeistern",
        "page.news.btn.readmore": "Ansehen",
        // LOCATIONS
        // LOCATIONS
        // LOCATIONS
        // LOCATIONS
        "page.locations.hero.headline": "zuverlässig und <br>schnell",
        "page.locations.headline": "Standorte",
        "page.locations.subline": "Hier sind wir",
        "page.locations.btn.showonmap": "Auf google maps anzeigen",
        "page.locations.datapolicy.p": `
            Mit dem Laden von Google Maps stimmen Sie den
            <a href="https://policies.google.com/privacy"
                target="_blank">Datenschutzbestimmungen
            </a> 
            von Google zu.
        `,
        "page.locations.datapolicy.btn": "Google Maps erlauben",
        "page.locations.joinus.headline": "Komm in unser Team!",
        "page.locations.joinus.p": `
            Wir sind immer auf der Suche nach neuen Mitarbeitern und
            Studenten (Schülern). Bewirb Dich auf eine passende Stelle oder schicke
            uns direkt eine Initiativbewerbung!
        `,
        "page.locations.joinus.btn.tojobs": "Zu den Jobs",
        "page.locations.joinus.btn.termine": "Messe/Events",
        "page.locations.locations.1.name": "Zentrale Barsbüttel",
        "page.locations.locations.1.lat": 53.57738575984663,
        "page.locations.locations.1.lng": 10.194030079061232,
        "page.locations.locations.1.street": "Rahlstedter Straße 13 ",
        "page.locations.locations.1.city": "22885 Barsbüttel",
        "page.locations.locations.1.ansprechpartner": "Tjark Süchting",
        "page.locations.locations.1.ansprechpartner_work": "Leitung Marketing & Vertrieb",
        "page.locations.locations.1.tel": "+49 40 682875 0",
        "page.locations.locations.1.mail": "t.suechting@sinus-nt.de",
        "page.locations.locations.1.gmaps_link": "https://www.google.com/maps/dir//Sinus+Nachrichtentechnik+GmbH,+Rahlstedter+Str.+13,+22885+Barsb%C3%BCttel/@53.5825116,10.1125133,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x47b18b4d587415ed:0x93d4666cbf6795d3!2m2!1d10.1949134!2d53.5825399?entry=ttu",
        "page.locations.locations.2.name": "Standort Greifswald",
        "page.locations.locations.2.lat": 54.09015391849636,
        "page.locations.locations.2.lng": 13.349884422846102,
        "page.locations.locations.2.street": "Ziegelhof 7",
        "page.locations.locations.2.city": "17489 Greifswald",
        "page.locations.locations.2.ansprechpartner": "Richard Kubisch",
        "page.locations.locations.2.ansprechpartner_work": "Standortleiter/Projektleiter",
        "page.locations.locations.2.tel": "+49 3834 3542 100",
        "page.locations.locations.2.mail": "greifswald@sinus-nt.de",
        "page.locations.locations.2.gmaps_link": "https://www.google.com/maps/dir//Sinus+Nachrichtentechnik+GmbH,+Ziegelhof+7,+17489+Greifswald/@54.0900504,13.2669157,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x47ab753b73b3d09f:0xe5594870a0617e2b!2m2!1d13.3493158!2d54.0900785?entry=ttu",
        "page.locations.locations.3.name": "Standort Unna",
        "page.locations.locations.3.lat": 51.56353714571139,
        "page.locations.locations.3.lng": 7.682040327634304,
        "page.locations.locations.3.street": "Kamener Straße 110",
        "page.locations.locations.3.city": "59425 Unna",
        "page.locations.locations.3.ansprechpartner": "Michael Fritsch",
        "page.locations.locations.3.ansprechpartner_work": "Standortleiter/Projektleiter",
        "page.locations.locations.3.tel": "+49 2307 916402 0",
        "page.locations.locations.3.mail": "unna@sinus-nt.de",
        "page.locations.locations.3.gmaps_link": "https://www.google.com/maps/dir//Kamener+Stra%C3%9Fe+110,+Unna/@51.5637595,7.6362063,13z/data=!4m8!4m7!1m0!1m5!1m1!1s0x47b912d952c1e417:0x4863c1b19450ff85!2m2!1d7.6774055!2d51.5637667?entry=ttu",
        "page.locations.locations.4.name": "Standort Pforzheim",
        "page.locations.locations.4.lat": 48.8589028,
        "page.locations.locations.4.lng": 8.5101162,
        "page.locations.locations.4.street": "Welschenäckerstraße 10",
        "page.locations.locations.4.city": "75177 Pforzheim",
        "page.locations.locations.4.ansprechpartner": "Christof Fricke",
        "page.locations.locations.4.ansprechpartner_work": "Standortleiter/Projektleiter",
        "page.locations.locations.4.tel": "+49 7231 46940 10",
        "page.locations.locations.4.mail": "pforzheim@sinus-nt.de",
        "page.locations.locations.4.gmaps_link": "https://www.google.com/maps/dir//Welschen%C3%A4ckerstra%C3%9Fe+10,+75177+Pforzheim/@48.8589028,8.5101162,9.32z/data=!4m8!4m7!1m0!1m5!1m1!1s0x4797717f60963325:0x3dbb92617ba7c5a4!2m2!1d8.7183336!2d48.914264?entry=ttu",
        "page.locations.locations.5.name": "Standort Ludwigsburg",
        "page.locations.locations.5.lat": 48.892817659598805,
        "page.locations.locations.5.lng": 9.239116994305553,
        "page.locations.locations.5.street": "Voithstraße 4-6",
        "page.locations.locations.5.city": "71640 Ludwigsburg",
        "page.locations.locations.5.ansprechpartner": "Henri Rumbolz",
        "page.locations.locations.5.ansprechpartner_work": "Standortleiter",
        "page.locations.locations.5.tel": "+49 7141 29660",
        "page.locations.locations.5.mail": "vertrieb@sinus-nt.de",
        "page.locations.locations.5.gmaps_link": "https://www.google.com/maps/dir//Blickle+Leitstellen%26Kommunikationstechnik+GmbH%26Co.KG,+Voithstra%C3%9Fe+4-6,+71640+Ludwigsburg/@48.8927378,9.0300775,10.71z/data=!4m8!4m7!1m0!1m5!1m1!1s0x4799cf36f7fed131:0xb4c125c2fb109f86!2m2!1d9.2362113!2d48.8914254?entry=ttu",
        // UNSERE WERTE
        // UNSERE WERTE
        // UNSERE WERTE
        // UNSERE WERTE
        //* ... dynamic slider
        "page.values.hero.slide.1.work": "Geschäftsführer",
        "page.values.hero.slide.1.name": "Marcus Landschof",
        "page.values.hero.slide.1.headline": "Weil jede Sekunde zählt",
        "page.values.headline": "Unsere Werte",
        "page.values.subline": "SINUS — 24/7 Einsatzbereit seit 1983",
        "page.values.p.1": `
            Im Mittelpunkt sämtlicher Prozesse, Tätigkeiten und Überlegungen stehen die
            Bedürfnisse und Wünsche unserer Kunden. Danach richten wir unsere Lösungen
            und Dienstleitungen konsequent aus, um eine hohe Kundenzufriedenheit 
            zu erreichen.
        `,
        "page.values.p.2": `
            Wir sind ambitioniert und gehen immer mit unserer „ingenieurgetriebenen“ 
            Entwicklungs- und IT-Technik-Leidenschaft neue Lösungswege, um ein optimales 
            Ziel zu erreichen. Sämtliche Projekte, ob groß oder klein, unterstützen 
            uns bei der stetigen Verbesserung unserer Prozesse und der Ausrichtung 
            an den Kundenbedarf. Gleichzeitig sind wir sehr stolz mit verlässlichen 
            und hochwertigen Lösungen und Produkten alle Einsatzkräfte bei ihrer 
            täglichen Arbeit für die Sicherheit und Gesundheit der Bevölkerung 
            zu unterstützen. Unser starkes Miteinander und der Zusammenhalt im Team 
            bilden die Basis für unseren Erfolg und die stetige Weiterentwicklung 
            des Unternehmens.
        `,
        "page.values.portfolio.subline": "Unser Produktportfolio",
        "page.values.portfolio.p": `
            ... steht für Lösungen auf <strong>höchstem technischem Niveau</strong> 
            in den Bereichen:
        `,
        "page.values.portfolio.digitalalarm": "Funk und Alarmierung",
        "page.values.portfolio.wachenelw": "Fahrzeuge&shy;kommunikation",
        "page.values.portfolio.leitsysteme": "Leitstellen&shy;systeme",
        "page.values.portfolio.repair": "Geräte und Zubehör",
        "page.values.portfolio.sprachfunk": "Digitalfunk",
        "page.values.portfolio.specials": "Sonderlösungen",
        "page.values.btn.partner": "Partner",
        "page.values.btn.team": "Unser Team",
        "page.values.btn.contact": "Kontakt",
        // ABOUT
        // ABOUT
        // ABOUT
        // ABOUT
        "page.about.headline": "Über Sinus",
        "page.about.subline": "Kurz und bündig",
        "page.about.section.1.li.1": "Gründung April 1983",
        "page.about.section.1.li.2": "Gesellschaftergeführtes, mittelständisches Unternehmen",
        "page.about.section.1.li.3": "Geschäftsführung Marcus Landschof",
        "page.about.section.1.li.4": "Organisches Wachstum: 11 Mitarbeitende in 2011, ca. 100 Mitarbeitende Stand heute",
        "page.about.section.1.li.5": "100% unabhängig - langfristige Ziele führen zum Erfolg",
        "page.about.section.1.p": `
            Als eines von Deutschlands führenden Unternehmen in der Entwicklung und 
            Projektierung von hochverfügbaren und integrierten Kommunikationssystemen 
            für Anwendungen der kritischen Kommunikation in den Märkten:
        `,
        "page.about.portfolio.bos": "BOS",
        "page.about.portfolio.stadtwerke": "Stadtwerke",
        "page.about.portfolio.maritim": "Maritim",
        "page.about.portfolio.opnv": "ÖPNV",
        "page.about.portfolio.industry": "Industrie",
        "page.about.portfolio.airport": "Flughafen",
        "page.about.section.2.subline": "Außerdem",
        "page.about.section.2.p.1": `
        ... bieten wir Ihnen Beratung, Planung, Realisierung 
        und Servicierung in sämtlichen Bereichen an.
        `,
        "page.about.section.2.p.2": `
            Das Ziel eines jeden Projektes ist die partnerschaftliche 
            Zusammenarbeit und die gemeinsame Zielerreichung mit dem Kunden.
        `,
        "page.about.section.3.subline": "Standorte",
        "page.about.section.3.li.1": "Standorte: Barsbüttel bei Hamburg,",
        "page.about.section.3.li.2": "Greifswald (MV), Unna (NRW), Pforzheim (BW), Ludwigsburg (BW)",
        "page.about.section.4.subline": "Starkes Partnernetzwerk für bundesweite Projektumsetzung",
        "page.about.section.4.li.1": "DT aus Berlin",
        "page.about.section.4.li.2": "ETF aus Eisleben (Sachsen-Anhalt)",
        "page.about.section.4.li.3": "ITK Klein aus Altdorf (Bayern)",
        "page.about.section.4.li.4": "WTG aus Coesfeld (NRW)",
        "page.about.section.5.subline": "Leistungsspektrum",
        "page.about.section.5.li.1": "Entwicklung Kommunikationsmanagementsysteme",
        "page.about.section.5.li.2": "IT-Technik",
        "page.about.section.5.li.3": "Antennentechnik",
        "page.about.section.5.li.4": "Haustechnik",
        "page.about.section.5.li.5": "skalierbare Lösungen für Telefonanlagen",
        "page.about.section.5.li.6": "elektronische Lautsprecheranlagen (ELA)",
        "page.about.section.5.li.7": "Leitstellentechnik",
        "page.about.section.5.li.8": "technische Modernisierungen von Einsatzleitwagen",
        "page.about.section.5.li.9": "Wartungen und Reparaturen von Funkgeräten",
        "page.about.section.5.li.10": "Funkanlagen u.v.m.",
        // MANAGEMENT
        // MANAGEMENT
        // MANAGEMENT
        // MANAGEMENT
        "page.management.headline": "Management",
        "page.management.subline": "Gesellschaftergeführt, innovativ und lösungsorientiert",
        "page.management.p.1": `
            In jedem Projekt versuchen wir den Bedarf jeder Anwenderin und jedes 
            Anwenders genau zu ermitteln und präzise umzusetzen. Dies gelingt nur, 
            wenn man das WIR in den Fokus setzt. Ein Projekt kann aus unserer Sicht 
            nur erfolgreich umgesetzt werden, wenn man die extremen Positionen 
            „der Kunde“ und „der Lieferant“ verwirft und „das TEAM“ in den Mittelpunkt 
            setzt. So geben wir alles dafür, um mit unseren Kommunikationslösungen 
            die bestmögliche Unterstützung zu bieten.
        `,
        "page.management.p.2": `
            Durch überzeugende Qualität, hervorragenden Kundenservice und Flexibilität 
            wollen wir uns als Unternehmen stetig verbessern. 100%-ige Unabhängigkeit 
            ermöglicht uns einen agilen Umgang mit technischem Wandel.
        `,
        "page.management.p.3": `
            Dabei haben wir ein langfristiges, nachhaltiges und ökologisches 
            Ziel vor Augen.
        `,
        "page.management.imagealt": "Marcus Landschof - Geschäftsführer",
        // UMWELT
        // UMWELT
        // UMWELT
        // UMWELT
        "page.environment.headline": "Umwelt",
        "page.environment.subline": "Nachhaltigkeit hat Vorrang",
        "page.environment.p": `
            Um unsere Umwelt zu schonen und nachfolgenden Generationen eine lebenswerte 
            Welt zu hinterlassen, basieren unsere Aktivitäten auf nachhaltigem Handeln. 
            Wir hinterfragen unseren Umgang mit Ressourcen, Waren und Sachwerten. 
            Verbesserungsvorschläge in Bezug auf ökologischere Lösungen bewerten wir 
            innerhalb der Teams. Aktuelle Projekte sind die sukzessive Umstellung der 
            Firmenfahrzeuge auf E-Mobilität sowie auch der Bau eines energieeffizienten 
            und ökologischen Firmensitzes in Barsbüttel.
        `,
        "page.environment.btn.about": "Mehr über Uns",
        "page.environment.btn.news": "Aktuelles",
        // TEAM
        // TEAM
        // TEAM
        // TEAM
        "page.team.hero.headline": "Zuverlässig und <br>schnell",
        "page.team.headline": "Unser Team",
        "page.team.subline.1": "Partnerschaftlich, Fair & Zukunftsorientiert",
        "page.team.subline.2": "Hier ein kleiner Einblick in unser Team",
        "page.team.member.1.name": "Marcus Landschof",
        "page.team.member.1.position": "Geschäftsführer",
        "page.team.member.1.bgimg": "https://liveicom.azureedge.net/sinus/img/members/Marcus_Landschof_Geschäftsführer_3G9A4542.jpg",
        "page.team.member.2.name": "Bianca Drieschner",
        "page.team.member.2.position": "Sachbearbeiterin Verwaltung",
        "page.team.member.2.bgimg": "https://liveicom.azureedge.net/sinus/img/members/Bianca_Drieschner_Sachbearbeiterin_Verwaltung_3G9A5084.jpg",
        "page.team.member.3.name": "Helge Schlinzig",
        "page.team.member.3.position": "Techniker Sonder- und Fahrzeugtechnik",
        "page.team.member.3.bgimg": "https://liveicom.azureedge.net/sinus/img/members/Helge_Schlinzig_Techniker_Sonder-und_Fahrzeugtechnik_3G9A6927.jpg",
        "page.team.member.4.name": "Tjark Süchting",
        "page.team.member.4.position": "Leitung Marketing & Vertrieb",
        "page.team.member.4.bgimg": "https://liveicom.azureedge.net/sinus/img/members/Tjark-Süchting_Vertriebsaußendienst_3G9A6807.jpg",
        "page.team.member.5.name": "Tobias Swiderski",
        "page.team.member.5.position": "Teamleiter IT",
        "page.team.member.5.bgimg": "https://liveicom.azureedge.net/sinus/img/members/Tobias_Swiderski_Techniker_Systemtechnik_3G9A4957.jpg",
        "page.team.member.6.name": "Serhat Cevik",
        "page.team.member.6.position": "Spartenleiter Entwicklung",
        "page.team.member.6.bgimg": "https://liveicom.azureedge.net/sinus/img/members/Serhat_Cevik_Spartenleiter_Entwicklung_3G9A5528.jpg",
        "page.team.member.7.name": "Mike Demmin",
        "page.team.member.7.position": "Projektassistenz Systemtechnik",
        "page.team.member.7.bgimg": "https://liveicom.azureedge.net/sinus/img/members/Mike_Demmin_Projektassistenz_Systemtechnik_3G9A6005.jpg",
        "page.team.member.8.name": "Carmen Anders",
        "page.team.member.8.position": "Abteilungsleiterin Verwaltung",
        "page.team.member.8.bgimg": "https://liveicom.azureedge.net/sinus/img/members/Carmen_Anders_Abteilungsleiterin_Verwaltung_3G9A5790.jpg",
        "page.team.member.9.name": "Frederic Westensee",
        "page.team.member.9.bgimg": "https://liveicom.azureedge.net/sinus/img/members/Frederic_Westensee.jpg",
        "page.team.member.9.position": "Techniker Systemtechnik",
        "page.team.member.10.name": "Sascha Grimlitza",
        "page.team.member.10.position": "Projektmanager Systemtechnik",
        "page.team.member.10.bgimg": "https://liveicom.azureedge.net/sinus/img/members/Sascha_Grimlitza.jpg",
        "page.team.member.11.name": "Ingo Reuter",
        "page.team.member.11.position": "Projektmanager Informationstechnologie Systemtechnik",
        "page.team.member.11.bgimg": "https://liveicom.azureedge.net/sinus/img/members/Ingo_Stadthalter.jpg",
        "page.team.member.12.name": "Bea Arnz",
        "page.team.member.12.position": "Projektmanagerin/Systemtechnik",
        "page.team.member.12.bgimg": "https://liveicom.azureedge.net/sinus/img/members/Bea_Arnz.jpg",
        "page.team.btn.about": "Mehr über Uns",
        "page.team.btn.news": "News",
        // PARTNER
        // PARTNER
        // PARTNER
        // PARTNER
        "page.partner.hero.headline": "zuverlässig und <br>schnell",
        "page.partner.headline": "Unsere Partner",
        "page.partner.subline": "Eine starke Gemeinschaft für alle Anforderungen",
        "page.partner.p": `
            Um eine passgenaue Lösung für die Anforderungen unserer Kunden gewährleisten 
            zu können, stellen wir hohe Ansprüche an langfristige Partner und Lieferanten, 
            gleichzeitig bieten wir eine stabile Geschäftsbeziehung.
        `,
        // ZERTIFIKATE
        // ZERTIFIKATE
        // ZERTIFIKATE
        // ZERTIFIKATE
        "page.certificates.hero.headline": "zuverlässig und <br>schnell",
        "page.certificates.headline": "Unsere Zertifikate",
        "page.certificates.subline": "Wir setzen Standards",
        // VERBÄNDE
        // VERBÄNDE
        // VERBÄNDE
        // VERBÄNDE
        "page.associations.hero.headline": "zuverlässig und <br>schnell",
        "page.associations.headline": "Verbände",
        "page.associations.subline": "Gemeinsame Ziele verbinden",
        // CONTACT
        // CONTACT
        // CONTACT
        // CONTACT
        "page.contact.heroheading": "zuverlässig und <br>schnell",
        "page.contact.heading": "Kontakt",
        "page.contact.form.heading": "Oder benutzen Sie gerne unser Kontaktformular",
        "page.contact.form.topics.1": "Termin vereinbaren",
        "page.contact.form.topics.2": "Angebot anfordern",
        "page.contact.form.topics.3": "Support-Anfrage",
        "page.contact.form.topics.4": "Sonstiges Thema",
        "page.contact.form.topics.5": "Rückruf",
        "page.contact.form.field.name": "Name",
        "page.contact.form.field.email": "E-Mail",
        "page.contact.form.field.firmname": "Organisation",
        "page.contact.form.field.phone": "Telefon",
        "page.contact.form.field.topic": "Ihr Anliegen",
        "page.contact.form.field.subject": "Betreff",
        "page.contact.form.field.message": "Ihre Nachricht",
        "page.contact.form.btn.sending": "Wird geschickt...",
        "page.contact.form.btn.send": "Absenden",
        "page.contact.form.field.sendingfeedback.success": "Wir haben Ihre Nachricht erhalten!",
        "page.contact.form.field.sendingfeedback.error": "Fehler beim absenden der Nachricht",
        "page.contact.locations.1.dividerheadline": "",
        "page.contact.locations.1.headline": "Sonder- und Fahrzeugtechnik",
        "page.contact.locations.1.name": "Zentrale Barsbüttel",
        "page.contact.locations.1.street": "Rahlstedter Straße 13 ",
        "page.contact.locations.1.city": "22885 Barsbüttel",
        "page.contact.locations.1.ansprechpartner": "Tjark Süchting",
        "page.contact.locations.1.ansprechpartner_work": "Leitung Marketing & Vertrieb",
        "page.contact.locations.1.tel": "+49 40 682875 25",
        "page.contact.locations.1.mail": "t.suechting@sinus-nt.de",
        "page.contact.locations.1.color": "--green",
        "page.contact.locations.2.dividerheadline": "",
        "page.contact.locations.2.headline": "",
        "page.contact.locations.2.name": "Zentrale Barsbüttel",
        "page.contact.locations.2.street": "Rahlstedter Straße 13 ",
        "page.contact.locations.2.city": "22885 Barsbüttel",
        "page.contact.locations.2.ansprechpartner": "Marcus Landschof",
        "page.contact.locations.2.ansprechpartner_work": "Geschäftsführer",
        "page.contact.locations.2.tel": "+49 40 682875 0",
        "page.contact.locations.2.mail": "barsbuettel@sinus-nt.de",
        "page.contact.locations.2.color": "--green",
        "page.contact.locations.3.dividerheadline": "",
        "page.contact.locations.3.headline": "",
        "page.contact.locations.3.name": "Standort Greifswald",
        "page.contact.locations.3.street": "Ziegelhof 7",
        "page.contact.locations.3.city": "17489 Greifswald",
        "page.contact.locations.3.ansprechpartner": "Richard Kubisch",
        "page.contact.locations.3.ansprechpartner_work": "Standortleiter/Projektleiter",
        "page.contact.locations.3.tel": "+49 3834 3542 100",
        "page.contact.locations.3.mail": "greifswald@sinus-nt.de",
        "page.contact.locations.3.color": "--yellow",
        "page.contact.locations.4.dividerheadline": "",
        "page.contact.locations.4.headline": "",
        "page.contact.locations.4.name": "Standort Unna",
        "page.contact.locations.4.street": "Kamener Straße 110",
        "page.contact.locations.4.city": "59425 Unna",
        "page.contact.locations.4.ansprechpartner": "Thomas Sievers",
        "page.contact.locations.4.ansprechpartner_work": "Standortleiter/Projektleiter",
        "page.contact.locations.4.tel": "+49 2307 916402 0",
        "page.contact.locations.4.mail": "unna@sinus-nt.de",
        "page.contact.locations.4.color": "--greenLight",
        "page.contact.locations.5.dividerheadline": "",
        "page.contact.locations.5.headline": "",
        "page.contact.locations.5.name": "Standort Entwicklung | Pforzheim",
        "page.contact.locations.5.street": "Welschenäckerstraße 10",
        "page.contact.locations.5.city": "75177 Pforzheim",
        "page.contact.locations.5.ansprechpartner": "Serhat Cevik",
        "page.contact.locations.5.ansprechpartner_work": "Leiter Entwicklung",
        "page.contact.locations.5.tel": "+49 7231 46940 10",
        "page.contact.locations.5.mail": "pforzheim@sinus-nt.de",
        "page.contact.locations.5.color": "--gray",
        "page.contact.locations.6.dividerheadline": "",
        "page.contact.locations.6.headline": "",
        "page.contact.locations.6.name": "Standort Ludwigsburg",
        "page.contact.locations.6.street": "Voithstraße 4-6",
        "page.contact.locations.6.city": "71640 Ludwigsburg",
        "page.contact.locations.6.ansprechpartner": "Henri Rumbolz",
        "page.contact.locations.6.ansprechpartner_work": "Standortleiter/Projektleiter",
        "page.contact.locations.6.tel": "+49 7141 29660",
        "page.contact.locations.6.mail": "ludwigsburg@sinus-nt.de",
        "page.contact.locations.6.color": "--gray",
        // HINWEISGEBERSCHUTZ
        // HINWEISGEBERSCHUTZ
        // HINWEISGEBERSCHUTZ
        // HINWEISGEBERSCHUTZ
        "page.hinweisgeberschutz.hero.headline": "zuverlässig und <br>vertrauensvoll",
        "page.hinweisgeberschutz.headline": "Hinweisgeberschutz",
        "page.hinweisgeberschutz.subline": "Anonyme Einsendungen",
        "page.hinweisgeberschutz.section.1.p.1": `
            Die Sinus Nachrichtentechnik GmbH legt höchsten Wert auf die Einhaltung
            gesetzlicher Vorschriften und ethischer Grundsätze. Dies gehört zu den
            wesentlichen Bestandteilen der Unternehmenskultur. Unsere
            Mitarbeiterinnen und Mitarbeiter sind dazu angehalten, jederzeit
            verantwortungsbewusst und ethisch zu handeln. Um diesen Ansprüchen
            gerecht zu werden, ist es wichtig von einem möglichem Fehlverhalten
            Kenntnis zu erlangen und dieses zu unterbinden.
        `,
        "page.hinweisgeberschutz.section.1.p.2": `
            Der Schutz von Hinweisgebern und Betroffenen hat für uns höchste
            Priorität. Einen wichtigen Baustein stellt hierbei unser
            Hinweisgeberschutzsystem dar. Dies ermöglicht den Hinweisgebern
            Verdachtsmomente oder Verstöße gegen Regeln vertraulich zu melden.
        `,
        "page.hinweisgeberschutz.section.1.p.3": `
            Das Hinweisgeberschutzsystem erreichen Sie über das nachfolgende
            Kontaktformular. Bitte beachten Sie, dass die Hinterlegung einer
            E&#8209;Mailadresse optional ist. Dies ermöglicht im Bedarfsfall jedoch
            eine direkte Kommunikation mit Ihnen.
        `,
        "page.hinweisgeberschutz.form.field.name": "Name",
        "page.hinweisgeberschutz.form.field.email": "E-Mail",
        "page.hinweisgeberschutz.form.field.phone": "Telefon",
        "page.hinweisgeberschutz.form.field.subject": "Betreff",
        "page.hinweisgeberschutz.form.field.message": "Ihre Nachricht",
        "page.hinweisgeberschutz.form.btn.send": "Absenden",
        "page.hinweisgeberschutz.form.btn.sending": "Wird gesendet...",
        "page.hinweisgeberschutz.form.success": "Ihre Nachricht wurde gesendet!",
        "page.hinweisgeberschutz.form.error": "Fehler beim absenden Ihrer Nachricht!",
        "page.hinweisgeberschutz.section.2.p.1": `
            Zusätzlich bieten wir Ihnen die Möglichkeit uns postalisch zu
            kontaktieren. Hierzu richten Sie den Schriftwechsel bitte an:
        `,
        "page.hinweisgeberschutz.section.2.p.2": `
            <strong>Vertraulich – Hinweisgeberstelle</strong> <br />
            Sinus Nachrichtentechnik GmbH <br />
            Rahlstedter Straße 13 <br />
            22885 Barsbüttel <br />
        `,
        "page.hinweisgeberschutz.section.2.p.3": `
            Ihre Meldungen werden von unserer Seite selbstverständlich zu jeder Zeit
            streng vertraulich behandelt.
        `,
        "page.hinweisgeberschutz.section.2.p.4": `
            Des Weiteren stehen Ihnen die offiziellen Meldewege des
            <a
                href="https://www.bkms-system.net/bkwebanon/report/channels?id=bkarta&language=ger"
                target="_blank"
                rel="noopener noreferrer"
            >
                Bundeskartellamtes
            </a>
            sowie des Bundesamtes für
            <a
                href="https://formulare.bfj.bund.de/ffw/action/invoke.do?id=externeMeldestelle"
                target="_blank"
                rel="noopener noreferrer"
            >
                Justiz
            </a>
            zur Verfügung.
        `,
    },
    // -- ENGLISH
    // -- ENGLISH
    // -- ENGLISH
    // -- ENGLISH
    // -- ENGLISH
    // -- ENGLISH
    // -- ENGLISH
    // -- ENGLISH
    // -- ENGLISH
    // -- ENGLISH
    // -- ENGLISH
    // -- ENGLISH
    // -- ENGLISH
    // -- ENGLISH
    // -- ENGLISH
    // -- ENGLISH ---------------------------------------------------------------
    // -- ENGLISH ---------------------------------------------------------------
    // -- ENGLISH ---------------------------------------------------------------
    // -- ENGLISH ---------------------------------------------------------------
    // -- ENGLISH
    // -- ENGLISH
    // -- ENGLISH
    // -- ENGLISH
    // -- ENGLISH
    // -- ENGLISH
    // -- ENGLISH
    // -- ENGLISH
    // -- ENGLISH
    // -- ENGLISH
    // -- ENGLISH
    // -- ENGLISH
    // -- ENGLISH
    // -- ENGLISH
    // -- ENGLISH
    // -- ENGLISH
    // -- ENGLISH
    en: {
        // GENERAL
        // GENERAL
        // GENERAL
        // GENERAL
        "menu.topbar.locations": `
            Mecklenburg-Western Pomerania · North Rhine-Westphalia · Baden-Wuerttemberg · Schleswig-Holstein
        `,
        "menu.page.home": "Home",
        "menu.page.loesungen": "Solutions",
        "menu.page.loesungen.leitsysteme": "(Emergency) Dispatch Systems",
        "menu.page.loesungen.wachenelw": "Emergency Operations Center and mobile command vehicles",
        "menu.page.loesungen.einsatznavigation": "Mission Navigation",
        "menu.page.loesungen.sprachdatenfunk": "Voice and Data Communication",
        "menu.page.loesungen.digitalalarm": "Digital Alert Systems",
        "menu.page.loesungen.repair": "Maintenance/Repairs",
        "menu.page.loesungen.it": "IT-Services",
        "menu.page.about": "About Us",
        "menu.page.about.niederlassungen": "Locations",
        "menu.page.about.unserewerte": "Our Values",
        "menu.page.about.about": "About Sinus",
        "menu.page.about.management": "Management",
        "menu.page.about.umwelt": "Environment",
        "menu.page.about.team": "The Team",
        "menu.page.about.partner": "Partners",
        "menu.page.about.certificates": "Certificates",
        "menu.page.about.verbaende": "Associations",
        "menu.page.news": "News",
        "menu.page.news.termine": "Events",
        "menu.page.news.wirwachsen": "We Are Expanding",
        "menu.page.news.news": "News",
        "menu.page.career": "Career",
        "menu.page.contact": "Contact",
        "btn.readmore": "Read More",
        "fetch.posts.loading": "Loading posts...",
        "fetch.posts.error": "Posts could not be loaded.",
        "fetch.posts.empty": "No posts found.",
        "fetch.post.loading": "Loading post...",
        "fetch.post.error": "Post could not be loaded.",
        "pagepreviews.leitstellen.headline": "(Emergency) Dispatch Systems",
        "pagepreviews.leitstellen.p": `
         When every second counts, our MECC system offers a reliable solution.`,
        "pagepreviews.wachenelw.headline": "Emergency Operations Center and mobile command vehicles",
        "pagepreviews.wachenelw.p": `
        Reliable and fast communication between emergency teams during operations.
        `,
        "pagepreviews.einsatznavigation.headline": "Mission Navigation",
        "pagepreviews.einsatznavigation.p": `
            Efficient TETRA Communication & Navigation – Flexible. Robust. Connected.
        `,
        "pagepreviews.sprachdaten.headline": "Voice and Data Communication",
        "pagepreviews.sprachdaten.p": `
            Radio systems for voice and data communication are a key factor today.
        `,
        "pagepreviews.digitalalarm.headline": "Digital Alert Systems",
        "pagepreviews.digitalalarm.p": `
             After an emergency call is triggered, an effective alerting system is crucial.
        `,
        "pagepreviews.repair.headline": "Maintenance/Repairs",
        "pagepreviews.repair.p": `
            Our professional workshops safeguard your investment.
        `,
        "pagepreviews.itservice.headline": "IT Services",
        "pagepreviews.itservice.p": `
            Establishing, maintaining, and supporting IT infrastructures requires a strong partner. Benefit from our long-standing experience.
        `,
        "footer.col.about.heading": "About Us",
        "footer.col.about.gmaplink": "Locations on Google Maps",
        "footer.col.about.link.team": "Team",
        "footer.col.about.link.partner": "Partners",
        "footer.col.about.link.certificates": "Certificates",
        "footer.col.about.link.verbaende": "Associations",
        "footer.col.about.link.karriere": "Career Opportunities",
        "footer.col.downloads.heading": "Downloads & Software",
        "footer.col.downloads.link.teamviewer": "TeamViewer QuickSupport",
        "footer.col.downloads.link.alf": "Terms and Conditions",
        "footer.col.downloads.link.repform": "Repair Order Form",
        "footer.col.downloads.link.freeform": `
            Exemption Certificate <br />
            in accordance with § 48b (1) of the Income Tax Act (EStG)
        `,
        "footer.col.location.ludwigsburg.heading": "Office <br />Ludwigsburg",
        "footer.col.location.ludwigsburg.address": `
            Voithstraße 4-6 <br />
            71640 Ludwigsburg
        `,
        "footer.col.location.barsbuettel.heading": "Headquarter <br />Barsbüttel",
        "footer.col.location.barsbuettel.address": `
            Rahlstedter Straße 13 <br />
            22885 Barsbüttel
        `,
        "footer.col.location.greifwald.heading": "Office <br />Greifswald",
        "footer.col.location.greifwald.address": `
            Ziegelhof 7 <br />
            17489 Greifswald
        
        `,
        "footer.col.location.unna.heading": "Office <br />Unna",
        "footer.col.location.unna.address": `
            Kamener Straße 110 <br />
            59425 Unna        
        `,
        "footer.col.location.pforzheim.heading": "Development Office <br />Ludwigsburg ",
        "footer.col.location.pforzheim.address": `
            Welschenäckerstraße 10 <br />
            75177 Pforzheim
        `,
        "footer.bottombar.copyright": "@ Copyright SINUS Nachrichtentechnik GmbH",
        "footer.bottombar.link.privacy": "Privacy Policy",
        "footer.bottombar.link.imprint": "Imprint",
        "footer.bottombar.link.hinweisgeberschutz": "Whistleblower Protection Act",
        // FILES
        // FILES
        // FILES
        // FILES
        // FILES
        "file.pdf.mecc.info": "https://liveicomcdn.blob.core.windows.net/sinus/files/MECC_2024_EN.pdf",
        "file.pdf.mecc.info.name": "MECC Product Brochure",
        // FORM
        // FORM
        // FORM
        // FORM
        // FORM
        // FORM
        "form.placeholder.required": "Required",
        "form.placeholder.select": "Please Select",
        // modals
        // modals
        // modals
        // modals
        // modals
        "modal.btn.close": "Close",
        "modal.contact.headline.top": "General Contact Form",
        "modal.contact.form.field.topic": "Your Request",
        "modal.contact.form.field.topic.leitstellensysteme": "(Emergency) Dispatch Systems",
        "modal.contact.form.field.topic.wachen-elw": "Emergency Operations Center and mobile command vehicles",
        "modal.contact.form.field.topic.einsatznavigation": "Mission Navigation",
        "modal.contact.form.field.topic.sprach-datenfunk": "Voice and Data Communication",
        "modal.contact.form.field.topic.digitale-alarmierung": "Digital Alert Systems",
        "modal.contact.form.field.topic.wartung-reparaturen": "Maintenance/Repairs",
        "modal.contact.form.field.topic.it": "IT-Services",
        "modal.contact.form.field.ansprache": "Title",
        "modal.contact.form.field.ansprache.1": "Ms",
        "modal.contact.form.field.ansprache.2": "Mr",
        "modal.contact.form.field.ansprache.3": "Other",
        "modal.contact.form.field.firstname": "First name",
        "modal.contact.form.field.lastname": "Last name",
        "modal.contact.form.field.firmname": "Company",
        "modal.contact.form.field.email": "Email",
        "modal.contact.form.field.phone": "Phone",
        "modal.contact.form.field.bundesland": "Federal State",
        "modal.contact.form.field.bundesland.1": "Baden-Württemberg",
        "modal.contact.form.field.bundesland.2": "Bavaria",
        "modal.contact.form.field.bundesland.3": "Berlin",
        "modal.contact.form.field.bundesland.4": "Brandenburg",
        "modal.contact.form.field.bundesland.5": "Bremen",
        "modal.contact.form.field.bundesland.6": "Hamburg",
        "modal.contact.form.field.bundesland.7": "Hesse",
        "modal.contact.form.field.bundesland.8": "Mecklenburg-Vorpommern",
        "modal.contact.form.field.bundesland.9": "Lower Saxony",
        "modal.contact.form.field.bundesland.10": "North Rhine-Westphalia",
        "modal.contact.form.field.bundesland.11": "Rhineland-Palatinate",
        "modal.contact.form.field.bundesland.12": "Saarland",
        "modal.contact.form.field.bundesland.13": "Saxony",
        "modal.contact.form.field.bundesland.14": "Sachsen-Anhalt",
        "modal.contact.form.field.bundesland.15": "Schleswig-Holstein",
        "modal.contact.form.field.bundesland.16": "Thuringia",
        "modal.contact.form.field.message": "Your Message",
        "modal.contact.form.field.privacy": "Privacy Policy",
        "modal.contact.form.field.privacytext": "By submitting this form, you agree that the data you provide will be collected and stored electronically. For more information, please refer to our <a href='/datenschutz'>privacy policy.</a>",
        "modal.contact.form.btn.send": "Send",
        "modal.contact.form.btn.sending": "Sending...",
        "modal.contact.form.sendingfeedback.success": "Your message has been sent successfully!",
        "modal.contact.form.sendingfeedback.error": "Error sending your message!",
        "modal.contact.headline.bottom": "Get in touch with the right person – directly",
        "modal.contact.btn.locations": "Our Locations",
        // 404
        // 404
        // 404
        // 404
        // 404
        "page.404.headline": "404",
        "page.404.subline": "Page not found",
        "page.404.btn.home": "Back to Home",
        // specials
        // specials
        // specials
        // specials
        // specials
        "special.stoerer.btn.close": "Close",
        "special.stoerer.subline": "Hamburger Founders' Award 2024",
        "special.stoerer.btn.readmore": "Read More",
        "special.stoerer.p": "We have been awarded the category of Rising Star!",
        // HOME
        // HOME
        // HOME
        // HOME
        "page.home.hero.slider.1.work": "Project Manager Systems Engineering",
        "page.home.hero.slider.1.name": "Bea Arnz",
        "page.home.hero.slider.1.img": "https://liveicom.azureedge.net/sinus/img/members/Bea_Arnz_Projektmanagerin_Systemtechnik_3G9A7141.png",
        "page.home.hero.slider.1.headline": "Because every second counts",
        "page.home.hero.slider.2.work": "Head of Marketing & Sales",
        "page.home.hero.slider.2.name": "Tjark Süchting",
        "page.home.hero.slider.2.img": "https://liveicom.azureedge.net/sinus/img/members/tjark_suechting.png",
        "page.home.hero.slider.2.headline": "Because every second counts",
        "page.home.hero.slider.3.work": "IT Team Leader",
        "page.home.hero.slider.3.name": "Tobias Swiderski",
        "page.home.hero.slider.3.img": "https://liveicom.azureedge.net/sinus/img/members/Tobias-Swidersk.png",
        "page.home.hero.slider.3.headline": "Because every second counts",
        "page.home.hero.slider.4.work": "Technician for Systems Engineering",
        "page.home.hero.slider.4.name": "Frederic Westensee",
        "page.home.hero.slider.4.img": "https://liveicom.azureedge.net/sinus/img/members/Frederic-Westensee.png",
        "page.home.hero.slider.4.headline": "Because every second counts",
        "page.home.subline": "PROVIDING 24/7 SUPPORT SINCE 1983",
        "page.home.counter.seconds": "SECONDS",
        "page.home.counter.days": "DAYS",
        "page.home.counter.years": "YEARS",
        "page.home.counter.p.shortintroduction": `
            With over 40 years of experience as a manufacturer, system integrator, and wholesale distributor, we offer comprehensive products, solutions, and services for the entire field of communication technology.
            Being owner-managed, we design high-availability, integrated communication systems for almost all sectors.
        `,
        "page.home.circleinfo.1.title": "Public Safety Services",
        "page.home.circleinfo.1.text": "We provide expertise to emergency organizations across all sectors",
        "page.home.circleinfo.2.title": "Municipal Utilities",
        "page.home.circleinfo.2.text": "Securing regional services with us as your partner",
        "page.home.circleinfo.3.title": "Maritime",
        "page.home.circleinfo.3.text": "On all waters, not just in case of MAYDAY",
        "page.home.circleinfo.4.title": "Public Transport",
        "page.home.circleinfo.4.text": "Ensuring smooth connections to trams, buses, and subways",
        "page.home.circleinfo.5.title": "Industry",
        "page.home.circleinfo.5.text": "Forward thinking solutions for every sector.",
        "page.home.circleinfo.6.title": "Airports",
        "page.home.circleinfo.6.text": "Always happy landings",
        "page.home.circleinfo.7.title": "Get in Touch",
        "page.home.circleinfo.7.text": "We look forward to hearing from you",
        "page.home.circleinfo.7.btn": "Contact Us",
        "page.home.footer.cta.more": "More about us",
        "page.home.footer.cta.news": "News & Updates",
        // LEITSYSTEME
        // LEITSYSTEME
        // LEITSYSTEME
        // LEITSYSTEME
        "page.leitsysteme.hero.headline": "",
        "page.leitsysteme.headline": "(Emergency) Dispatch Systems",
        "page.leitsysteme.subline": "Where every moment makes a difference",
        "page.leitsysteme.p.1": `
            The ability to operate multiple systems and functions at the touch of a button — ideally in parallel and often simultaneously — is crucial to ensuring quick emergency response.
        `,
        "page.leitsysteme.p.2": `
            Our MECC communication system offers a highly available, flexible, and intuitively operable solution for both small and large control centers. Our communication management system can operate as a standalone solution or as a complete integration of the command and control system.
        `,
        "page.leitsysteme.p.3": `
            With its variety of interfaces and flexible configuration options, our MECC system can be incorporated into any control center, supporting all processes.
        `,
        "page.leitsysteme.p.4": `
            Following successful project implementation, our highly qualified team ensures continuous support — available 24/7.
        `,
        "page.leitsysteme.btn.infopdf": "MECC Product Brochure",
        "page.leitsysteme.btn.projectrequest": "Submit a Project Enquiry",
        // WACHEN ELW
        // WACHEN ELW
        // WACHEN ELW
        // WACHEN ELW
        "page.wachenelw.hero.headline": "",
        "page.wachenelw.headline": "Emergency Operations Center and mobile command vehicles",
        "page.wachenelw.subline": "Rapid, Reliable communication between emergency responders",
        "page.wachenelw.p.1": `
            Successful missions depend on reliable and swift communication between responders.
            During operations, a clear and precise functionality is essential.
        `,
        "page.wachenelw.p.2": `
            With the SEB VoIP Fire radio interface and our status displays and monitors, emergency response processes can be organized and operated with ease.
        `,
        "page.wachenelw.p.3": `
            For internal communication within (Emergency) Operations Centers and equipment facilities, we offer scalable solutions for telephone systems and electronic loudspeaker systems (ELA).
        `,
        "page.wachenelw.p.4": `
            Our team’s expertise and the efficiency of our solutions are proven in numerous projects, where command and control vehicles are upgraded with state-of-the-art technology after years of active duty.
        `,
        "page.wachenelw.btn.kontakt": "Contact Us",
        "page.wachenelw.btn.projectrequest": "Submit Enquiry",
        "page.wachenelw.dropdown.infomaterial": "Product Information",
        // einsatznavigation
        // einsatznavigation
        // einsatznavigation
        // einsatznavigation
        "page.einsatznavigation.hero.headline": "",
        "page.einsatznavigation.headline": "EFFICIENT TETRA NAVIGATION & RADIO CONTROL",
        "page.einsatznavigation.subline": "Flexible. Robust. Connected",
        "page.einsatznavigation.p.1": `
            The <strong>TETRAcontrol UBX</strong> for vehicles is a mobile digital radio and control solution that integrates navigation, communication, and data management. By connecting to Sepura or Motorola radios, it enables intuitive radio operation via an app, GPS and status forwarding, and mission navigation with automatic route activation. Rugged mission tablets, which can be connected via the serial interface, provide clear online and offline navigation and, thanks to versatile accessories, can be fully utilised for other applications at the incident site. Advanced features such as Bluetooth interfaces and LTE data transmission make it the ideal solution for emergency services. Modular, expandable, and customisable – for maximum efficiency in operations.
        `,
        "page.einsatznavigation.btn.kontakt": "Contact Us",
        "page.einsatznavigation.btn.projectrequest": "Submit Enquiry",
        "page.einsatznavigation.dropdown.infomaterial": "Product Information",
        // sprach datenfunk
        // sprach datenfunk
        // sprach datenfunk
        // sprach datenfunk
        "page.sprachdaten.hero.headline": "",
        "page.sprachdaten.headline": "Voice and Data Communication",
        "page.sprachdaten.subline": "One-Stop Solution – Analog & Digital",
        "page.sprachdaten.p.1": `
            Voice and data communication systems play a crucial role in information exchange across all business sectors. 
            Our comprehensive services cover the planning, setup, and maintenance of microwave transmission, analog and digital land stations, and wide-area Single Frequency Radio Network systems.
        
        `,
        "page.sprachdaten.btn.contact": "Contact Us",
        "page.sprachdaten.dropdown.infomaterial": "Product Information",
        "page.sprachdaten.btn.projectrequest": "Submit Enquiry",
        // DIGITALE ALARMIERUNG
        // DIGITALE ALARMIERUNG
        // DIGITALE ALARMIERUNG
        // DIGITALE ALARMIERUNG
        "page.digitalalarm.hero.headline": "",
        "page.digitalalarm.headline": "Digital Alert Systems",
        "page.digitalalarm.subline": "Our Effective Notification Systems",
        "page.digitalalarm.p": `
            Once an emergency call is triggered, effective alerting is essential.
            It ensures rapid and efficient coordination of responders, ensuring that relevant recipients are notified promptly.
        `,
        "page.digitalalarm.box.1.headline": "In an Emergency",
        "page.digitalalarm.box.1.p": `
            ...it’s imperative that first responders can be reached swiftly, no matter the location or the severity of the circumstances.
            In cases of lone work or hazardous surroundings, on-site personnel must be equipped to call for help rapidly and reliably.
        `,
        "page.digitalalarm.box.2.headline": "Our Solutions",
        "page.digitalalarm.box.2.p.1": `
            Our systems provide tailored solutions for fast, simultaneous, and reliable alerting via relay contacts and through various channels such as SMS, pagers, email, pre-recorded messages, canned voice and loudspeaker announcement.

        `,
        "page.digitalalarm.box.2.p.2": `
            As a wholesaler of radios and add-on equipment, we offer customized solutions for analog professional mobile radio, TETRA, DMR, maritime radio, and more.
        `,
        "page.digitalalarm.btn.projectrequest": "Submit Enquiry",
        // REPARATUREN
        // REPARATUREN
        // REPARATUREN
        // REPARATUREN
        "page.repair.hero.headline": "swift and <br/> reliable",
        "page.repair.headline": "Maintenance/Repairs",
        "page.repair.subline": "Dependable and Well-Planned Service for Your Operations!",
        "page.repair.p.1": `

            Maintaining the reliability of critical systems requires consistent care and servicing. 
            We offer maintenance contracts tailored to your needs, providing you with maximum security.
        `,
        "page.repair.p.2": `
                Repairs on defective devices—such as pagers, radios, and communication systems — are conducted on-site or at our facilities in Barsbüttel and Greifswald, using original parts from the manufacturer.
        `,
        "page.repair.btn.repairpdf": "Repair Order Form",
        "page.repair.btn.contact": "Enquiry",
        // IT SERVICE
        // IT SERVICE
        // IT SERVICE
        // IT SERVICE
        "page.itservice.hero.headline": "",
        "page.itservice.headline": "IT Services",
        "page.itservice.subline": "All-Round Service - Complete Peace of Mind",
        "page.itservice.p.1": `

            We support you in the planning, implementation, and ongoing operation of IT infrastructures — tailored to your specific needs! 
            Our services include everything from WLAN access points to complex site connectivity and the virtualization of entire control center systems.
        `,
        "page.itservice.p.2": `
            We focus on the entire IT infrastructure for communication management and command systems, ensuring optimal integration of all components.
        `,
        "page.itservice.p.3": `
            Following successful implementation we remain at your service for system updates and maintenance.
        `,
        "page.itservice.p.4": `
            We provide secure service through our expert team — available 24/7.
        `,
        "page.itservice.btn.contact": "Submit Enquiry",
        // KARRIERE
        // KARRIERE
        // KARRIERE
        // KARRIERE
        "page.career.hero.slide.1.work": "Head of Administration",
        "page.career.hero.slide.1.name": "Carmen Anders",
        "page.career.hero.slide.1.headline": "Because every Second Counts",
        "page.career.hero.slide.1.img": "https://liveicom.azureedge.net/sinus/img/members/carmen_anders.png",
        "page.career.headline": "Future-Driven Careers",
        "page.career.subline": "Our Philosophy: Together as One Team!",
        "page.career.p.1": `
            We firmly believe that a company’s success is largely determined by the sense of unity among all employees and is built on the collective dedication of all team members. Committed to this principle, we foster a working environment characterized by respect, appreciation, trust, equality, enjoyment, and mutual support.
        `,
        "page.career.p.2": `
            We believe in setting new team members up for success from day one. Our structured onboarding program, combined with mentorship and open feedback, ensures that every new colleague has a clear path to integration and feels connected, supported, and motivated to thrive.
        `,
        "page.career.chances.headline": "Promoting Young Talent",
        "page.career.chances.subline": "Your Chance – Let’s Make an Impact Together",
        "page.career.chances.p": `
            We view the need for well-trained professionals as a responsibility to actively contribute to education and training. 
            We aim to provide the best possible support to applicants who are motivated to start their careers. 
            It doesn’t matter whether it’s technical or commercial training, a dual study program, supervision of a bachelor’s thesis, or an internship — every application is welcome.

        `,
        "page.career.impressions.headline": "Benefits",
        "page.career.impressions.subline": "Why You’ll Love It Here",
        "page.career.impressions.li.1": "Onboarding Process",
        "page.career.impressions.li.2": "Open-Door Culture",
        "page.career.impressions.li.3": "Team Spirit",
        "page.career.impressions.li.4": "Mentoring Program",
        "page.career.impressions.li.5": "Meaningful Work (Emergency Services)",
        "page.career.impressions.li.6": "Flexible Working Hours",
        "page.career.impressions.li.7": "Overtime Account",
        "page.career.impressions.li.8": "30 Days of Vacation",
        "page.career.impressions.li.9": "Remote Work",
        "page.career.impressions.li.10": "Company Pension Plan – Employer Contributions Beyond Legal Requirements",
        "page.career.impressions.li.11": "Company Car",
        "page.career.impressions.li.12": "Smartphone",
        "page.career.impressions.li.13": "New, Eco-Friendly Building",
        "page.career.impressions.li.14": "Ergonomically Designed Workspace (height-adjustable desk, multiple monitors, etc.)",
        "page.career.impressions.li.15": "Free Drinks and Fruit",
        "page.career.impressions.li.16": "Internal and External Training Programs",
        "page.career.impressions.li.17": "Company Events",
        "page.career.impressions.li.18": "Well-Connected Location (Easy Motorway Access/Parking Provided)",
        "page.career.joblistings.headline": "Career Opportunities",
        "page.career.ctasection.subline": "Carmen Anders",
        "page.career.ctasection.jobtitle": "Head of Human Resources",
        "page.career.ctasection.p": `
            We can’t wait to get to know you. <br />
            Speculative applications? Definitely! <br />Feel free to reach out.
        `,
        "page.career.ctasection.btn.locations": "View Locations",
        "page.career.ctasection.btn.contact": "Get in Touch",
        // TERMINE
        // TERMINE
        // TERMINE
        // TERMINE
        "page.events.hero.headline": "Connecting with Tomorrow",
        "page.events.headline": "Events",
        "page.events.subline": "See You There",
        "page.events.btn.event": "View Event",
        // WIR WACHSEN
        // WIR WACHSEN
        // WIR WACHSEN
        // WIR WACHSEN
        "page.growth.hero.headline": "swift and <br/> reliable",
        "page.growth.headline": "We Are Expanding!",
        "page.growth.subline": "New Sinus Headquarters in Barsbüttel: Work with a Feel-Good Factor!",
        "page.growth.p.1": `

            At the end of 2023, we moved into our new <strong>energy-efficient</strong> and <strong>eco-friendly</strong> 
            office building in Barsbüttel. Energy recovery and a high degree of self-sufficiency ensure a future-oriented workplace.
            The three-story high building was designed with input from employees, tailored to meet their specific needs.

        `,
        "page.growth.p.2": `
                Be excited for what’s coming next — more exciting developments will be unveiled in the new building!

        `,
        // NEWS
        // NEWS
        // NEWS
        // NEWS
        "page.news.hero.headline": "Connecting with Tomorrow",
        "page.news.headline": "News",
        "page.news.subline": "Inspiring Innovations",
        "page.news.fetch.loading": "News loading...",
        "page.news.fetch.empty": "Sorry, no news available.",
        "page.news.fetch.error": "Unable to load news. Please try again later.",
        "page.news.btn.readmore": "Read more",
        // LOCATIONS
        // LOCATIONS
        // LOCATIONS
        // LOCATIONS
        "page.locations.hero.headline": "swift and <br/> reliable",
        "page.locations.headline": "Locations",
        "page.locations.subline": "Here We Are",
        "page.locations.btn.showonmap": "Show on Google Maps",
        "page.locations.datapolicy.p": `
            By using Google Maps you consent to Google’s
            <a href="https://policies.google.com/privacy"
                target="_blank">data privacy terms
            </a> 
        `,
        "page.locations.datapolicy.btn": "Allow Google Maps Access",
        "page.locations.joinus.headline": "Join Our Team!",
        "page.locations.joinus.p": `

            We're always in search of fresh talent, including employees and students. Apply for an open position or send us your speculative application!
        `,
        "page.locations.joinus.btn.tojobs": "View career opportunities",
        "page.locations.joinus.btn.termine": "Exhibitions/Events",
        "page.locations.locations.1.name": "Headquarter Barsbüttel",
        "page.locations.locations.1.lat": 53.57738575984663,
        "page.locations.locations.1.lng": 10.194030079061232,
        "page.locations.locations.1.street": "Rahlstedter Straße 13 ",
        "page.locations.locations.1.city": "22885 Barsbüttel",
        "page.locations.locations.1.ansprechpartner": "Tjark Süchting",
        "page.locations.locations.1.ansprechpartner_work": "Head of Marketing & Sales",
        "page.locations.locations.1.tel": "+49 40 682875 0",
        "page.locations.locations.1.mail": "t.suechting@sinus-nt.de",
        "page.locations.locations.1.gmaps_link": "https://www.google.com/maps/dir//Sinus+Nachrichtentechnik+GmbH,+Rahlstedter+Str.+13,+22885+Barsb%C3%BCttel/@53.5825116,10.1125133,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x47b18b4d587415ed:0x93d4666cbf6795d3!2m2!1d10.1949134!2d53.5825399?entry=ttu",
        "page.locations.locations.2.name": "Office Greifswald",
        "page.locations.locations.2.lat": 54.09015391849636,
        "page.locations.locations.2.lng": 13.349884422846102,
        "page.locations.locations.2.street": "Ziegelhof 7",
        "page.locations.locations.2.city": "17489 Greifswald",
        "page.locations.locations.2.ansprechpartner": "Richard Kubisch",
        "page.locations.locations.2.ansprechpartner_work": "Office Supervisor and Project Manager",
        "page.locations.locations.2.tel": "+49 3834 3542 100",
        "page.locations.locations.2.mail": "greifswald@sinus-nt.de",
        "page.locations.locations.2.gmaps_link": "https://www.google.com/maps/dir//Sinus+Nachrichtentechnik+GmbH,+Ziegelhof+7,+17489+Greifswald/@54.0900504,13.2669157,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x47ab753b73b3d09f:0xe5594870a0617e2b!2m2!1d13.3493158!2d54.0900785?entry=ttu",
        "page.locations.locations.3.name": "Office Unna",
        "page.locations.locations.3.lat": 51.56353714571139,
        "page.locations.locations.3.lng": 7.682040327634304,
        "page.locations.locations.3.street": "Kamener Straße 110",
        "page.locations.locations.3.city": "59425 Unna",
        "page.locations.locations.3.ansprechpartner": "Michael Fritsch",
        "page.locations.locations.3.ansprechpartner_work": "Office Supervisor and Project Manager",
        "page.locations.locations.3.tel": "+49 2307 916402 0",
        "page.locations.locations.3.mail": "unna@sinus-nt.de",
        "page.locations.locations.3.gmaps_link": "https://www.google.com/maps/dir//Kamener+Stra%C3%9Fe+110,+Unna/@51.5637595,7.6362063,13z/data=!4m8!4m7!1m0!1m5!1m1!1s0x47b912d952c1e417:0x4863c1b19450ff85!2m2!1d7.6774055!2d51.5637667?entry=ttu",
        "page.locations.locations.4.name": "Office Pforzheim",
        "page.locations.locations.4.lat": 48.8589028,
        "page.locations.locations.4.lng": 8.5101162,
        "page.locations.locations.4.street": "Welschenäckerstraße 10",
        "page.locations.locations.4.city": "75177 Pforzheim",
        "page.locations.locations.4.ansprechpartner": "Christof Fricke",
        "page.locations.locations.4.ansprechpartner_work": "Office Supervisor and Project Manager",
        "page.locations.locations.4.tel": "+49 7231 46940 10",
        "page.locations.locations.4.mail": "pforzheim@sinus-nt.de",
        "page.locations.locations.4.gmaps_link": "https://www.google.com/maps/dir//Welschen%C3%A4ckerstra%C3%9Fe+10,+75177+Pforzheim/@48.8589028,8.5101162,9.32z/data=!4m8!4m7!1m0!1m5!1m1!1s0x4797717f60963325:0x3dbb92617ba7c5a4!2m2!1d8.7183336!2d48.914264?entry=ttu",
        "page.locations.locations.5.name": "Office Ludwigsburg",
        "page.locations.locations.5.lat": 48.892817659598805,
        "page.locations.locations.5.lng": 9.239116994305553,
        "page.locations.locations.5.street": "Voithstraße 4-6",
        "page.locations.locations.5.city": "71640 Ludwigsburg",
        "page.locations.locations.5.ansprechpartner": "Henri Rumbolz",
        "page.locations.locations.5.ansprechpartner_work": "Office Supervisor",
        "page.locations.locations.5.tel": "+49 7141 29660",
        "page.locations.locations.5.mail": "vertrieb@sinus-nt.de",
        "page.locations.locations.5.gmaps_link": "https://www.google.com/maps/dir//Blickle+Leitstellen%26Kommunikationstechnik+GmbH%26Co.KG,+Voithstra%C3%9Fe+4-6,+71640+Ludwigsburg/@48.8927378,9.0300775,10.71z/data=!4m8!4m7!1m0!1m5!1m1!1s0x4799cf36f7fed131:0xb4c125c2fb109f86!2m2!1d9.2362113!2d48.8914254?entry=ttu",
        // UNSERE WERTE
        // UNSERE WERTE
        // UNSERE WERTE
        // UNSERE WERTE
        "page.values.hero.slide.1.work": "Managing Director",
        "page.values.hero.slide.1.name": "Marcus Landschof",
        "page.values.hero.slide.1.headline": "Because every second counts",
        "page.values.headline": "Our Values",
        "page.values.subline": "SINUS — Committed 24/7 Since 1983",
        "page.values.p.1": `

            Our customers' needs and expectations lie at the center of everything we do. 
            We adapt our solutions and services accordingly to deliver outstanding customer satisfaction.
        `,
        "page.values.p.2": `
            We are ambitious and always pursue new solutions with our "engineering-driven" passion for development and IT technology to achieve optimal results. All projects, whether small or large, help us continuously improve our processes and align them with customer needs. At the same time, we take great pride in supporting all emergency personnel in their daily work to ensure the safety and health of the population with reliable and high-quality solutions and products. Our strong collaboration and team spirit form the foundation for our success and the ongoing development of the company.
        `,
        "page.values.portfolio.subline": "Our Product Portfolio",
        "page.values.portfolio.p": `
            ...represents solutions at the <strong>highest technical level</strong> 
            in the following areas:
        `,
        "page.values.portfolio.digitalalarm": "Radio and Alerting",
        "page.values.portfolio.wachenelw": "(Emergency) Vehicle Communication",
        "page.values.portfolio.leitsysteme": "(Emergency) Dispatch Systems",
        "page.values.portfolio.repair": "Devices and Accessories",
        "page.values.portfolio.sprachfunk": "Digital Radio",
        "page.values.portfolio.specials": "Custom Solutions",
        "page.values.btn.partner": "Partners",
        "page.values.btn.team": "Our Team",
        "page.values.btn.contact": "Contact Us",
        // ABOUT
        // ABOUT
        // ABOUT
        // ABOUT
        "page.about.headline": "About Sinus",
        "page.about.subline": "Quick Facts",
        "page.about.section.1.li.1": "Founded in April 1983",
        "page.about.section.1.li.2": "Owner-managed, medium-sized company",
        "page.about.section.1.li.3": "Managing Director: Marcus Landschof",
        "page.about.section.1.li.4": "Organic growth: 11 employees in 2011, approximately 90 employees today",
        "page.about.section.1.li.5": "100% independent - long-term goals lead to success",
        "page.about.section.1.p": `
            Recognized as one of Germany's foremost companies, we focus on the development and planning of reliable and integrated communication systems for critical communication applications in the following sectors:
        `,
        "page.about.portfolio.bos": "Public Safety Services",
        "page.about.portfolio.stadtwerke": "Municipal Utilities",
        "page.about.portfolio.maritim": "Maritime",
        "page.about.portfolio.opnv": "Public Transport",
        "page.about.portfolio.industry": "Industry",
        "page.about.portfolio.airport": "Airports",
        "page.about.section.2.subline": "Further more...",
        "page.about.section.2.p.1": `


        ... we offer you consulting, planning, implementation, and servicing in all areas.
        `,
        "page.about.section.2.p.2": `
                The goal of every project is a collaborative partnership and achieving shared objectives with our customers.

        `,
        "page.about.section.3.subline": "Locations",
        "page.about.section.3.li.1": "Barsbüttel near Hamburg, Germany",
        "page.about.section.3.li.2": "Greifswald (MV), Unna (NRW), Pforzheim (BW), Ludwigsburg (BW), Germany",
        "page.about.section.3.li.3": "Blickle Leitstellentechnik in Ludwigsburg (BW), Germany",
        "page.about.section.4.subline": "Comprehensive Network for Nationwide Project Implementation",
        "page.about.section.4.li.1": "DT in Berlin",
        "page.about.section.4.li.2": "ETF in Eisleben (Saxony-Anhalt)",
        "page.about.section.4.li.3": "ITK Klein in Altdorf (Bavaria)",
        "page.about.section.4.li.4": "WTG in Coesfeld (NRW)",
        "page.about.section.5.subline": "Service Portfolio",
        "page.about.section.5.li.1": "Development of Communication Management Systems",
        "page.about.section.5.li.2": "IT-Engineering",
        "page.about.section.5.li.3": "Antenna Technology",
        "page.about.section.5.li.4": "Building Technology",
        "page.about.section.5.li.5": "Scalable Solutions for Telephone Systems",
        "page.about.section.5.li.6": "Electronic Public Address Systems (PA)",
        "page.about.section.5.li.7": "(Emergency) Control Center Technology",
        "page.about.section.5.li.8": "Technical upgrades of command vehicles",
        "page.about.section.5.li.9": "Maintenance and repair of radio equipment",
        "page.about.section.5.li.10": "Radio systems and More",
        // MANAGEMENT
        // MANAGEMENT
        // MANAGEMENT
        // MANAGEMENT
        "page.management.headline": "Management",
        "page.management.subline": "Owner-Managed, Innovative, and Solution-Oriented",
        "page.management.p.1": `

            In every project, we strive to understand and address the needs of each user. This is only achievable through a strong focus on teamwork. We believe that a project can only succeed when we set aside the sometimes conflicting perspectives of "customer" and "supplier" and prioritize "the TEAM." By doing this, we position ourselves to provide the best possible support with our communication solutions.
        `,
        "page.management.p.2": `

             Through compelling quality, excellent customer service, and flexibility, we aim to continuously improve as a company. 
             The autonomy as an owner-managed company allows us to adapt quickly to technological changes and maintain an agile approach.
        `,
        "page.management.p.3": `
            Our overall goal is to achieve a sustainable and ecological outcome in the long run.
        `,
        "page.management.imagealt": "Marcus Landschof - Managing Director",
        // UMWELT
        // UMWELT
        // UMWELT
        // UMWELT
        "page.environment.headline": "Environment",
        "page.environment.subline": "Sustainability Comes First",
        "page.environment.p": `

        To protect our environment and leave a livable world for generations to come, our activities are based on sustainable practices. 
        We critically eassess valuate our use of resources, goods, and assets. 
        Ideas for more eco-friendly solutions are discussed within our teams. Our current projects involve the gradual shift of company vehicles to electric mobility and the building of an energy-efficient and environmentally friendly headquarters in Barsbüttel."
        `,
        "page.environment.btn.about": "Read More",
        "page.environment.btn.news": "News and Updates",
        // TEAM
        // TEAM
        // TEAM
        // TEAM
        "page.team.hero.headline": "swift and <br/> reliable",
        "page.team.headline": "Our Team",
        "page.team.subline.1": "Supportive, Fair & Future-Minded",
        "page.team.subline.2": "Meet some of the remarkable people in our team",
        "page.team.member.1.name": "Marcus Landschof",
        "page.team.member.1.position": "Managing Director",
        "page.team.member.2.name": "Bianca Drieschner",
        "page.team.member.2.position": "Administration",
        "page.team.member.3.name": "Helge Schlinzig",
        "page.team.member.3.position": "Technician for (Special) Vehicle Technology",
        "page.team.member.4.name": "Tjark Süchting",
        "page.team.member.4.position": "Head of Marketing & Sales",
        "page.team.member.5.name": "Tobias Swiderski",
        "page.team.member.5.position": "IT Team Leader",
        "page.team.member.6.name": "Serhat Cevik",
        "page.team.member.6.position": "Head of IT-Development",
        "page.team.member.7.name": "Mike Demmin",
        "page.team.member.7.position": "Project Assistant for Systems Engineering",
        "page.team.member.8.name": "Carmen Anders",
        "page.team.member.8.position": "Head of Administration",
        "page.team.member.9.name": "Frederic Westensee",
        "page.team.member.9.position": "Technician for Systems Engineering",
        "page.team.member.10.name": "Sascha Grimlitza",
        "page.team.member.10.position": "Project Manager Systems Engineering",
        "page.team.member.11.name": "Ingo Reuter",
        "page.team.member.11.position": "Project Manager IT Systems Engineering",
        "page.team.member.12.name": "Bea Arnz",
        "page.team.member.12.position": "Project Manager Systems Engineering",
        "page.team.member.13.name": "Karsten Meinke",
        "page.team.member.13.position": "Technician for Systems Engineering",
        "page.team.btn.about": "Read More",
        "page.team.btn.news": "News and Updates",
        // PARTNER
        // PARTNER
        // PARTNER
        // PARTNER
        "page.partner.hero.headline": "swift and <br/> reliable",
        "page.partner.headline": "Our Partners",
        "page.partner.subline": "A Comprehensive Network for All Requirements",
        "page.partner.p": `

            To guarantee tailored solutions for our customers, we set high standards for long-term partners and suppliers, while also providing a stable business relationship.
        `,
        // ZERTIFIKATE
        // ZERTIFIKATE
        // ZERTIFIKATE
        "page.certificates.hero.headline": "swift and <br/> reliable",
        "page.certificates.headline": "Awards & Certificates",
        "page.certificates.subline": "We set high standards",
        // VERBÄNDE
        // VERBÄNDE
        // VERBÄNDE
        // VERBÄNDE
        "page.associations.hero.headline": "swift and <br/> reliable",
        "page.associations.headline": "Associations ",
        "page.associations.subline": "Common goals unite us!",
        // CONTACT
        // CONTACT
        // CONTACT
        // CONTACT
        "page.contact.heroheading": "swift and <br/> reliable",
        "page.contact.heading": "Get in Touch",
        "page.contact.form.heading": "Or feel free to use our contact form",
        "page.contact.form.topics.1": "Schedule an Appointment",
        "page.contact.form.topics.2": "Request a Quote",
        "page.contact.form.topics.3": "Support Enquiry",
        "page.contact.form.topics.4": "Other Topic",
        "page.contact.form.topics.5": "Callback",
        "page.contact.form.field.name": "Name",
        "page.contact.form.field.email": "Email",
        "page.contact.form.field.firmname": "Organization",
        "page.contact.form.field.phone": "Phone",
        "page.contact.form.field.topic": "Your Request",
        "page.contact.form.field.subject": "Subject",
        "page.contact.form.field.message": "Your Message",
        "page.contact.form.btn.sending": "Sending...",
        "page.contact.form.btn.send": "Send",
        "page.contact.form.field.sendingfeedback.success": "We have received your message!",
        "page.contact.form.field.sendingfeedback.error": "Error sending the message",
        "page.contact.locations.1.dividerheadline": "",
        "page.contact.locations.1.headline": "(Special) Vehicle Technology",
        "page.contact.locations.1.name": "Headquarter Barsbüttel",
        "page.contact.locations.1.street": "Rahlstedter Straße 13 ",
        "page.contact.locations.1.city": "22885 Barsbüttel",
        "page.contact.locations.1.ansprechpartner": "Tjark Süchting",
        "page.contact.locations.1.ansprechpartner_work": "Head of Marketing & Sales",
        "page.contact.locations.1.tel": "+49 40 682875 25",
        "page.contact.locations.1.mail": "t.suechting@sinus-nt.de",
        "page.contact.locations.1.color": "--green",
        "page.contact.locations.2.dividerheadline": "",
        "page.contact.locations.2.headline": "(Emergency) Operation Center Technology",
        "page.contact.locations.2.name": "Headquarter Barsbüttel",
        "page.contact.locations.2.street": "Rahlstedter Straße 13 ",
        "page.contact.locations.2.city": "22885 Barsbüttel",
        "page.contact.locations.2.ansprechpartner": "Marcus Landschof",
        "page.contact.locations.2.ansprechpartner_work": "Managing Director",
        "page.contact.locations.2.tel": "+49 40 682875 0",
        "page.contact.locations.2.mail": "barsbuettel@sinus-nt.de",
        "page.contact.locations.2.color": "--green",
        "page.contact.locations.3.dividerheadline": "",
        "page.contact.locations.3.headline": "",
        "page.contact.locations.3.name": "Office Greifswald",
        "page.contact.locations.3.street": "Ziegelhof 7",
        "page.contact.locations.3.city": "17489 Greifswald",
        "page.contact.locations.3.ansprechpartner": "Richard Kubisch",
        "page.contact.locations.3.ansprechpartner_work": "Office Supervisor/Project Manager",
        "page.contact.locations.3.tel": "+49 3834 3542 100",
        "page.contact.locations.3.mail": "greifswald@sinus-nt.de",
        "page.contact.locations.3.color": "--yellow",
        "page.contact.locations.4.dividerheadline": "",
        "page.contact.locations.4.headline": "",
        "page.contact.locations.4.name": "Office Unna",
        "page.contact.locations.4.street": "Kamener Straße 110",
        "page.contact.locations.4.city": "59425 Unna",
        "page.contact.locations.4.ansprechpartner": "Thomas Sievers",
        "page.contact.locations.4.ansprechpartner_work": "Office Supervisor/Project Manager",
        "page.contact.locations.4.tel": "+49 2307 916402 0",
        "page.contact.locations.4.mail": "unna@sinus-nt.de",
        "page.contact.locations.4.color": "--greenLight",
        "page.contact.locations.5.dividerheadline": "",
        "page.contact.locations.5.headline": "",
        "page.contact.locations.5.name": "Development Office | Pforzheim",
        "page.contact.locations.5.street": "Welschenäckerstraße 10",
        "page.contact.locations.5.city": "75177 Pforzheim",
        "page.contact.locations.5.ansprechpartner": "Serhat Cevik",
        "page.contact.locations.5.ansprechpartner_work": "Head of Development",
        "page.contact.locations.5.tel": "+49 7231 46940 10",
        "page.contact.locations.5.mail": "pforzheim@sinus-nt.de",
        "page.contact.locations.5.color": "--gray",
        "page.contact.locations.6.dividerheadline": "",
        "page.contact.locations.6.headline": "",
        "page.contact.locations.6.name": "Office Ludwigsburg",
        "page.contact.locations.6.street": "Voithstraße 4-6",
        "page.contact.locations.6.city": "71640 Ludwigsburg",
        "page.contact.locations.6.ansprechpartner": "Henri Rumbolz",
        "page.contact.locations.6.ansprechpartner_work": "Office Supervisor/Project Manager",
        "page.contact.locations.6.tel": "+49 7141 29660",
        "page.contact.locations.6.mail": "ludwigsburg@sinus-nt.de",
        "page.contact.locations.6.color": "--gray",
        // HINWEISGEBERSCHUTZ
        // HINWEISGEBERSCHUTZ
        // HINWEISGEBERSCHUTZ
        // HINWEISGEBERSCHUTZ
        "page.hinweisgeberschutz.hero.headline": "Reliable and <br>Trustworthy",
        "page.hinweisgeberschutz.headline": "Whistleblower <br/> Protection Act",
        "page.hinweisgeberschutz.subline": "Anonymous Submissions",
        "page.hinweisgeberschutz.section.1.p.1": `

            Sinus Nachrichtentechnik GmbH places the utmost importance on compliance with legal regulations and ethical principles. This is a fundamental part of our corporate culture. Our employees are encouraged to act responsibly and ethically at all times. To meet these standards, it is essential to be aware of any potential misconduct and to prevent it. This is where our whistleblower protection system comes into play. It allows whistleblowers to report suspicions or violations of rules in confidence.
        `,
        "page.hinweisgeberschutz.section.1.p.2": `
            The protection of whistleblowers and affected individuals is our top priority. An important component of this is our whistleblower protection system, which allows whistleblowers to report suspicions or violations of rules confidentially.
        `,
        "page.hinweisgeberschutz.section.1.p.3": `
            You can access the whistleblower protection system through the contact form below. Please note that providing an E&#8209;email address is optional. However, this allows for direct communication with you if needed.
        `,
        "page.hinweisgeberschutz.form.field.name": "Name",
        "page.hinweisgeberschutz.form.field.email": "Email",
        "page.hinweisgeberschutz.form.field.phone": "Phone",
        "page.hinweisgeberschutz.form.field.subject": "Subject",
        "page.hinweisgeberschutz.form.field.message": "Your Message",
        "page.hinweisgeberschutz.form.btn.send": "Send",
        "page.hinweisgeberschutz.form.btn.sending": "Sending...",
        "page.hinweisgeberschutz.form.success": "Your message has been sent!",
        "page.hinweisgeberschutz.form.error": "Error sending your message!",
        "page.hinweisgeberschutz.section.2.p.1": `
             Additionally, we offer you the option to contact us by mail. Please address any correspondence to:
        `,
        "page.hinweisgeberschutz.section.2.p.2": `
            <strong>Confidential – Whistleblower Reporting Office</strong> <br />
            Sinus Nachrichtentechnik GmbH <br />
            Rahlstedter Straße 13 <br />
            22885 Barsbüttel <br />
        `,
        "page.hinweisgeberschutz.section.2.p.3": `
            Your reports will, of course, be treated with strict confidentiality at all times.
        `,
        "page.hinweisgeberschutz.section.2.p.4": `
            Additionally, you can use to the official reporting channels of the 
            <a
                href="https://www.bkms-system.net/bkwebanon/report/channels?id=bkarta&language=ger"
                target="_blank"
                rel="noopener noreferrer"
            >
                Bundeskartellamtes
            </a>
            sowie des Bundesamtes für
            <a
                href="https://formulare.bfj.bund.de/ffw/action/invoke.do?id=externeMeldestelle"
                target="_blank"
                rel="noopener noreferrer"
            >
                Justiz
            </a>
            .
        `,
    },
};
